import ngeohash from 'ngeohash';
import { extractParticipantNamesFromRsvps, prefillSessionParticipants } from './session-launch.js';

export function initApp() {
    console.log('App.js loaded');

    // Check Firebase
    if (typeof firebase === 'undefined') {
        console.error('Firebase SDK not loaded');
        document.body.innerHTML += '<div style="color:red; position:fixed; top:0; z-index:9999;">Firebase SDK Missing</div>';
        return;
    }

    // Firebase Configuration
    const firebaseConfig = {
        apiKey: "AIzaSyCETBbfXEBAMWje1hTdglmsinwFL5A1Qas",
        authDomain: "cogrity-d45b1.firebaseapp.com",
        projectId: "cogrity-d45b1",
        storageBucket: "cogrity-d45b1.firebasestorage.app",
        messagingSenderId: "888215037728",
        appId: "1:888215037728:web:90c5e7709aca5cbd709945",
        measurementId: "G-BTM2S8ETST"
    };

    // Initialize Firebase
    try {
        if (!firebase.apps.length) {
            firebase.initializeApp(firebaseConfig);
            console.log('Firebase initialized');
        } else {
            console.log('Firebase already initialized');
        }
    } catch (e) {
        console.error('Firebase init error:', e);
    }

    const auth = firebase.auth();
    const db = firebase.firestore();

    // DOM Elements
    const dashboardScreen = document.getElementById('dashboard-screen');
    const scheduleScreen = document.getElementById('schedule-screen');
    const groupsScreen = document.getElementById('groups-screen');
    const sessionsScreen = document.getElementById('sessions-screen');
    const cardsScreen = document.getElementById('cards-screen');
    const settingsScreen = document.getElementById('settings-screen');

    // PDF State
    let pdfDoc = null;
    let pageNum = 1;
    let pageRendering = false;
    let pageNumPending = null;
    let renderTask = null;
    const canvas = document.getElementById('pdf-render');
    const ctx = canvas.getContext('2d');

    const tabFind = document.getElementById('tab-find');
    const tabManage = document.getElementById('tab-manage'); // New
    const tabCreate = document.getElementById('tab-create');
    const viewFind = document.getElementById('view-find');
    const viewManage = document.getElementById('view-manage'); // New
    const viewCreate = document.getElementById('view-create');
    const btnNearMe = document.getElementById('btn-near-me');
    const btnSearchZip = document.getElementById('btn-search-zip');
    const inputZip = document.getElementById('search-zip');
    const eventsList = document.getElementById('events-list');
    const myEventsList = document.getElementById('my-events-list');
    const myRsvpsList = document.getElementById('my-rsvps-list');
    const createEventForm = document.getElementById('create-event-form');
    const groupModal = document.getElementById('group-modal');
    const createGroupForm = document.getElementById('create-group-form');
    const createNewGroupLink = document.getElementById('create-new-group-link');
    const closeGroupModal = document.getElementById('close-group-modal');
    const cancelGroupModal = document.getElementById('cancel-group-modal');
    const eventGroupSelect = document.getElementById('evt-group');
    const groupsListContainer = document.getElementById('groups-list-container');
    const createGroupBtn = document.getElementById('create-group-btn');
    const groupModalTitle = document.getElementById('group-modal-title');
    const submitGroupBtn = document.getElementById('submit-group-btn');
    const groupAdminsSection = document.getElementById('group-admins-section');
    const groupAdminsInput = document.getElementById('group-admins');
    // Map Stuff
    const eventsMapContainer = document.getElementById('events-map-container');
    const btnViewList = document.getElementById('btn-view-list');
    const btnViewMap = document.getElementById('btn-view-map');
    let mapInstance = null;
    let mapMarkers = [];
    let currentView = 'list'; // 'list' or 'map'

    let editingEventId = null; // Track if editing
    let editingGroupId = null; // Track if editing group

    // Swipe State
    let touchStartX = 0;
    let touchEndX = 0;

    // Nav Links
    const navDashboard = document.getElementById('nav-dashboard');
    const userEmailSpan = document.getElementById('user-email');
    const settingsEmailInput = document.getElementById('settings-email');
    const settingsDisplayNameInput = document.getElementById('settings-display-name');
    const saveDisplayNameBtn = document.getElementById('save-display-name-btn');
    const messageDiv = document.getElementById('message');

    // Navigation Elements
    const mainHeader = document.getElementById('main-header');
    const sidebar = document.getElementById('sidebar');
    const bottomNav = document.getElementById('bottom-nav');
    const hamburgerBtn = document.getElementById('hamburger-btn');
    const sidebarOverlay = document.getElementById('sidebar-overlay');
    const userMenuBtn = document.getElementById('user-menu-btn');
    const userDropdown = document.getElementById('user-dropdown');
    const mainContent = document.getElementById('main-content');

    // Check if critical elements exist
    if (!hamburgerBtn) {
        console.error('Critical DOM elements missing');
        return;
    }

    // Screens Map
    const screens = {
        'dashboard': dashboardScreen,
        'schedule': scheduleScreen,
        'groups': groupsScreen,
        'sessions': sessionsScreen,
        'cards': cardsScreen,
        'settings': settingsScreen
    };

    // Initialize Journey Tracker
    let journeyTracker = null;

    // User Profile Cache
    let currentUserProfile = null;
    const userProfilesCache = new Map();

    // Client-side Router
    function navigateTo(screenName, updateHash = true) {
        console.log('Navigating to screen:', screenName);

        // Update hash without triggering hashchange event
        if (updateHash && window.location.hash !== `#/${screenName}`) {
            window.location.hash = screenName;
        }

        // Hide all screens
        Object.values(screens).forEach(screen => {
            if (screen) screen.style.display = 'none';
        });

        // Show requested screen
        if (screens[screenName]) {
            screens[screenName].style.display = 'block';
        }

        // Update active state in sidebar
        document.querySelectorAll('.sidebar a').forEach(link => link.classList.remove('active'));
        const activeLink = document.getElementById(`nav-${screenName}`);
        if (activeLink) activeLink.classList.add('active');

        // Update active state in bottom nav
        document.querySelectorAll('.b-nav-item').forEach(link => link.classList.remove('active'));
        const activeBLink = document.getElementById(`bnav-${screenName}`);
        if (activeBLink) activeBLink.classList.add('active');

        // Close menus if open
        closeSidebar();
        closeUserMenu();

        // Load data for specific screens
        if (screenName === 'groups') {
            renderGroupsList();
        }

        // Load PDF for cards screen
        if (screenName === 'cards') {
            loadPDF();
            setupPDFResizeHandler();
        }

        // Initialize journey tracker when dashboard is shown
        if (screenName === 'dashboard' && !journeyTracker) {
            const currentUser = auth.currentUser;
            if (currentUser && db) {
                journeyTracker = new JourneyTracker(db, currentUser);
            } else {
                console.error('Cannot initialize journey tracker: user or database not available');
            }
        }
    }

    // Handle hash changes (browser back/forward)
    function handleRoute() {
        const hash = window.location.hash.slice(1); // Remove the #
        const route = hash.startsWith('/') ? hash.slice(1) : hash; // Remove leading /

        // Default to dashboard if no route or invalid route
        const validRoutes = ['dashboard', 'schedule', 'groups', 'sessions', 'cards', 'settings'];
        const screenName = validRoutes.includes(route) ? route : 'dashboard';

        navigateTo(screenName, false); // false = don't update hash again
    }

    // Initialize router
    window.addEventListener('hashchange', handleRoute);

    // Legacy function for compatibility
    function showScreen(screenName) {
        navigateTo(screenName);
    }

    // Show Message
    function showMessage(text, type = 'success') {
        messageDiv.textContent = text;
        messageDiv.className = `message show ${type}`;
        setTimeout(() => {
            messageDiv.classList.remove('show');
        }, 5000);
    }

    async function getUserProfile(userId) {
        if (!userId) return null;
        if (userProfilesCache.has(userId)) {
            return userProfilesCache.get(userId);
        }

        try {
            const doc = await db.collection('publicProfiles').doc(userId).get();
            if (doc.exists) {
                const data = doc.data();
                const profile = { displayName: data.displayName || 'Member' };
                userProfilesCache.set(userId, profile);
                return profile;
            }
        } catch (error) {
            console.error('Error loading user profile:', error);
        }

        return null;
    }

    async function ensureCurrentUserProfile() {
        const currentUser = auth.currentUser;
        if (!currentUser) return null;

        const profile = await getUserProfile(currentUser.uid);
        if (profile) {
            currentUserProfile = profile;
            return profile;
        }

        const fallbackName = currentUser.displayName || 'Member';
        const fallbackProfile = { displayName: fallbackName };
        currentUserProfile = fallbackProfile;
        userProfilesCache.set(currentUser.uid, fallbackProfile);

        try {
            const profileData = {
                displayName: fallbackName,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            };
            await db.collection('users').doc(currentUser.uid).set(profileData, { merge: true });
            await db.collection('publicProfiles').doc(currentUser.uid).set(profileData, { merge: true });
        } catch (error) {
            console.error('Error creating fallback profile:', error);
        }

        return fallbackProfile;
    }

    async function getCurrentUserDisplayName() {
        if (currentUserProfile && currentUserProfile.displayName) {
            return currentUserProfile.displayName;
        }
        const profile = await ensureCurrentUserProfile();
        return profile ? profile.displayName : 'Member';
    }

    async function getDisplayNamesForUsers(userIds) {
        const names = new Map();
        const uniqueIds = Array.from(new Set(userIds)).filter(Boolean);
        const missing = [];

        uniqueIds.forEach((userId) => {
            if (userProfilesCache.has(userId)) {
                const profile = userProfilesCache.get(userId);
                names.set(userId, profile.displayName || 'Member');
            } else {
                missing.push(userId);
            }
        });

        if (missing.length > 0) {
            const profiles = await Promise.all(missing.map((userId) => getUserProfile(userId)));
            profiles.forEach((profile, index) => {
                const userId = missing[index];
                if (profile) {
                    names.set(userId, profile.displayName || 'Member');
                }
            });
        }

        return names;
    }

    async function updateUserRsvpDisplayNames(displayName) {
        try {
            const currentUser = auth.currentUser;
            if (!currentUser) return;

            const snapshot = await db.collection('rsvps')
                .where('userId', '==', currentUser.uid)
                .get();

            const updates = [];
            snapshot.forEach(doc => {
                const data = doc.data();
                if (data.displayName !== displayName) {
                    updates.push(doc.ref.update({
                        displayName,
                        updatedAt: firebase.firestore.FieldValue.serverTimestamp()
                    }));
                }
            });

            await Promise.all(updates);
        } catch (error) {
            console.error('Error updating RSVP display names:', error);
        }
    }

    async function updateUserJoinRequestDisplayName(displayName) {
        try {
            const currentUser = auth.currentUser;
            if (!currentUser) return;

            const snapshot = await db.collectionGroup('joinRequests')
                .where('userId', '==', currentUser.uid)
                .get();

            const updates = [];
            snapshot.forEach(doc => {
                updates.push(doc.ref.set({
                    displayName,
                    updatedAt: firebase.firestore.FieldValue.serverTimestamp()
                }, { merge: true }).catch(() => {}));
            });

            await Promise.all(updates);
        } catch (error) {
            console.error('Error updating join request display names:', error);
        }
    }

    // Calculate distance between two lat/lng points in miles (Haversine formula)
    function haversineDistance(lat1, lng1, lat2, lng2) {
        const R = 3958.8; // Earth radius in miles
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLng = (lng2 - lng1) * Math.PI / 180;
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLng / 2) * Math.sin(dLng / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }

    // Geocoding Function - Convert ZIP code to coordinates
    async function geocodeZipCode(zipCode) {
        try {
            // Using Nominatim (OpenStreetMap) geocoding service
            const response = await fetch(
                `https://nominatim.openstreetmap.org/search?postalcode=${zipCode}&country=US&format=json&limit=1`,
                {
                    headers: {
                        'User-Agent': 'Cogrity App'
                    }
                }
            );

            if (!response.ok) {
                throw new Error('Geocoding service unavailable');
            }

            const data = await response.json();

            if (data && data.length > 0) {
                return {
                    lat: parseFloat(data[0].lat),
                    lng: parseFloat(data[0].lon)
                };
            } else {
                throw new Error('ZIP code not found');
            }
        } catch (error) {
            console.error('Geocoding error:', error);
            // Return default coordinates (center of US) if geocoding fails
            return {
                lat: 39.8283,
                lng: -98.5795
            };
        }
    }

    // Modal Utility Class
    class Modal {
        constructor(elementId, options = {}) {
            this.modal = typeof elementId === 'string' ? document.getElementById(elementId) : elementId;
            this.options = {
                onClose: () => { },
                onOpen: () => { },
                ...options
            };
            this.isOpen = false;

            if (!this.modal) return;

            this.init();
        }

        init() {
            // Close button (x)
            const closeBtn = this.modal.querySelector('.modal-close');
            if (closeBtn) {
                // Note: We're adding a listener. If existing listeners aren't removed, they might both fire.
                // For this refactor, we will remove manual listeners in the codebase.
                closeBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.close();
                });
            }

            // Click outside
            this.modal.addEventListener('click', (e) => {
                if (e.target === this.modal) {
                    this.close();
                }
            });

            // ESC key
            this.handleEsc = (e) => {
                if (this.isOpen && e.key === 'Escape') {
                    this.close();
                }
            };
            document.addEventListener('keydown', this.handleEsc);
        }

        open() {
            this.modal.style.display = 'flex';
            this.isOpen = true;
            if (this.options.onOpen) this.options.onOpen();
        }

        close() {
            this.modal.style.display = 'none';
            this.isOpen = false;
            if (this.options.onClose) this.options.onClose();
        }

        destroy() {
            if (this.handleEsc) {
                document.removeEventListener('keydown', this.handleEsc);
            }
        }
    }

    // Dialog System
    function showDialog(options) {
        return new Promise((resolve) => {
            const modal = document.getElementById('dialog-modal');
            const title = document.getElementById('dialog-title');
            const message = document.getElementById('dialog-message');
            const inputContainer = document.getElementById('dialog-input-container');
            const input = document.getElementById('dialog-input');
            const confirmBtn = document.getElementById('dialog-confirm-btn');
            const cancelBtn = document.getElementById('dialog-cancel-btn');
            const closeBtn = document.getElementById('close-dialog-modal');

            // Set content
            title.textContent = options.title || 'Confirm';
            message.textContent = options.message || '';
            confirmBtn.textContent = options.confirmText || 'Confirm';
            cancelBtn.textContent = options.cancelText || 'Cancel';

            // Handle input field
            if (options.type === 'prompt') {
                inputContainer.style.display = 'block';
                input.value = options.defaultValue || '';
                input.placeholder = options.placeholder || '';
            } else {
                inputContainer.style.display = 'none';
            }

            // Show modal
            modal.style.display = 'flex';

            // Focus input if prompt
            if (options.type === 'prompt') {
                setTimeout(() => input.focus(), 100);
            }

            // Click outside handler
            const outsideClickHandler = (e) => {
                if (e.target === modal) {
                    resolve(options.type === 'prompt' ? null : false);
                    cleanup();
                }
            };
            modal.addEventListener('click', outsideClickHandler);

            // Cleanup function
            const cleanup = () => {
                modal.style.display = 'none';
                confirmBtn.onclick = null;
                cancelBtn.onclick = null;
                closeBtn.onclick = null;
                input.onkeydown = null;
                modal.removeEventListener('click', outsideClickHandler);
            };

            // Confirm handler
            confirmBtn.onclick = () => {
                if (options.type === 'prompt') {
                    resolve(input.value);
                } else {
                    resolve(true);
                }
                cleanup();
            };

            // Cancel handler
            const cancelHandler = () => {
                resolve(options.type === 'prompt' ? null : false);
                cleanup();
            };

            cancelBtn.onclick = cancelHandler;
            closeBtn.onclick = cancelHandler;

            // Enter key support for prompt
            if (options.type === 'prompt') {
                input.onkeydown = (e) => {
                    if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault();
                        confirmBtn.click();
                    } else if (e.key === 'Escape') {
                        cancelBtn.click();
                    }
                };
            }
        });
    }

    // Confirm dialog
    function confirmDialog(message, title = 'Confirm') {
        return showDialog({
            type: 'confirm',
            title: title,
            message: message,
            confirmText: 'Yes',
            cancelText: 'No'
        });
    }

    // Prompt dialog
    function promptDialog(message, title = 'Input', defaultValue = '', placeholder = '') {
        return showDialog({
            type: 'prompt',
            title: title,
            message: message,
            defaultValue: defaultValue,
            placeholder: placeholder,
            confirmText: 'OK',
            cancelText: 'Cancel'
        });
    }

    // Sidebar Logic
    function toggleSidebar() {
        console.log('Toggling sidebar');
        sidebar.classList.toggle('open');
        sidebarOverlay.classList.toggle('show');
    }

    function closeSidebar() {
        sidebar.classList.remove('open');
        sidebarOverlay.classList.remove('show');
    }

    // User Menu Logic
    function toggleUserMenu() {
        userDropdown.classList.toggle('show');
    }

    function closeUserMenu() {
        userDropdown.classList.remove('show');
    }

    // Event Listeners - Navigation
    if (hamburgerBtn) hamburgerBtn.addEventListener('click', toggleSidebar);
    if (sidebarOverlay) sidebarOverlay.addEventListener('click', closeSidebar);
    if (userMenuBtn) userMenuBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        toggleUserMenu();
    });

    // Close user menu when clicking outside
    document.addEventListener('click', (e) => {
        if (userMenuBtn && !userMenuBtn.contains(e.target) && userDropdown && !userDropdown.contains(e.target)) {
            closeUserMenu();
        }
    });

    // Sidebar Navigation Links
    ['dashboard', 'schedule', 'groups', 'sessions', 'cards'].forEach(page => {
        const link = document.getElementById(`nav-${page}`);
        if (link) {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                showScreen(page);
            });
        }
    });

    // Bottom Navigation Links
    ['dashboard', 'schedule', 'groups', 'settings'].forEach(page => {
        const link = document.getElementById(`bnav-${page}`);
        if (link) {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                showScreen(page);
            });
        }
    });

    // Settings Link
    const settingsLink = document.getElementById('nav-settings');
    if (settingsLink) settingsLink.addEventListener('click', (e) => {
        e.preventDefault();
        showScreen('settings');
    });

    // Logout - redirects to login page
    const logoutBtn = document.getElementById('nav-logout');
    if (logoutBtn) logoutBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        try {
            await auth.signOut();
            // Redirect to login page
            window.location.href = '/login.html';
        } catch (error) {
            console.error('Logout error:', error);
            showMessage('Error logging out. Please try again.', 'error');
        }
    });

    // Auth State Observer - Redirect to login page if not authenticated
    auth.onAuthStateChanged((user) => {
        console.log('Auth state changed:', user ? user.email : 'null');

        if (user) {
            // User is signed in
            ensureCurrentUserProfile().then((profile) => {
                const displayName = profile && profile.displayName ? profile.displayName : 'Member';
                if (userEmailSpan) userEmailSpan.textContent = `Name: ${displayName}`;
                if (settingsDisplayNameInput) settingsDisplayNameInput.value = displayName;
            });
            if (settingsEmailInput) settingsEmailInput.value = user.email;

            // Add authenticated class to body (CONTROLS VISIBILITY)
            document.body.classList.add('authenticated');

            // Let CSS handle navigation visibility
            if (sidebar) sidebar.style.display = '';
            if (bottomNav) bottomNav.style.display = '';
            if (mainHeader) mainHeader.style.display = '';

            // Show dashboard if not already on an authenticated screen
            const isOnAuthenticatedScreen = dashboardScreen.style.display === 'block' ||
                scheduleScreen.style.display === 'block' ||
                groupsScreen.style.display === 'block' ||
                cardsScreen.style.display === 'block' ||
                settingsScreen.style.display === 'block';

            if (!isOnAuthenticatedScreen) {
                // Use router to navigate based on hash or default to dashboard
                handleRoute();
            }
        } else {
            // User is signed out - redirect to login page
            console.log('No user session, redirecting to login...');
            window.location.href = '/login.html';
        }
    });

    if (saveDisplayNameBtn) {
        saveDisplayNameBtn.addEventListener('click', async (e) => {
            e.preventDefault();
            const displayName = settingsDisplayNameInput ? settingsDisplayNameInput.value.trim() : '';
            if (!displayName) {
                showMessage('Display name cannot be empty.', 'error');
                return;
            }

            try {
                const currentUser = auth.currentUser;
                if (!currentUser) {
                    showMessage('You must be logged in to update your name.', 'error');
                    return;
                }

                const profileData = {
                    displayName,
                    updatedAt: firebase.firestore.FieldValue.serverTimestamp()
                };
                await db.collection('users').doc(currentUser.uid).set(profileData, { merge: true });
                await db.collection('publicProfiles').doc(currentUser.uid).set(profileData, { merge: true });

                await currentUser.updateProfile({ displayName });
                currentUserProfile = { displayName };
                userProfilesCache.set(currentUser.uid, { displayName });
                await updateUserRsvpDisplayNames(displayName);
                await updateUserJoinRequestDisplayName(displayName);

                if (userEmailSpan) userEmailSpan.textContent = `Name: ${displayName}`;
                showMessage('Display name updated.', 'success');
            } catch (error) {
                console.error('Error updating display name:', error);
                showMessage('Failed to update display name.', 'error');
            }
        });
    }

    // ------------------------------------------------------------------
    // PDF Logic
    // ------------------------------------------------------------------

    /**
     * Get page info from document, resize canvas accordingly, and render page.
     * @param num Page number.
     */
    function renderPage(num) {
        if (renderTask) {
            renderTask.cancel();
            renderTask = null;
        }
        pageRendering = true;

        // Fetch page
        pdfDoc.getPage(num).then(function (page) {
            // Calculate scale to fit screen
            const container = document.querySelector('.cards-container');
            const desiredWidth = container.clientWidth;
            const desiredHeight = container.clientHeight;

            const viewportRaw = page.getViewport({ scale: 1 });
            const scaleX = desiredWidth / viewportRaw.width;
            const scaleY = desiredHeight / viewportRaw.height;
            const scaleToFit = Math.min(scaleX, scaleY) * 0.95; // 95% to leave margin

            const viewport = page.getViewport({ scale: scaleToFit });

            canvas.height = viewport.height;
            canvas.width = viewport.width;

            // Render PDF page into canvas context
            const renderContext = {
                canvasContext: ctx,
                viewport: viewport
            };
            const task = page.render(renderContext);
            renderTask = task;

            // Wait for render to finish
            task.promise.then(function () {
                if (renderTask === task) {
                    renderTask = null;
                }
                pageRendering = false;
                if (pageNumPending !== null) {
                    renderPage(pageNumPending);
                    pageNumPending = null;
                }
            }).catch((error) => {
                if (renderTask === task) {
                    renderTask = null;
                }
                pageRendering = false;
                if (error && error.name === 'RenderingCancelledException') {
                    return;
                }
                console.error('PDF render error:', error);
            });
        });

        // Update page counters
        document.getElementById('page-num-display').textContent = num + ' / ' + pdfDoc.numPages;
    }

    /**
     * If another page rendering in progress, waits until the rendering is
     * finised. Otherwise, executes rendering immediately.
     */
    function queueRenderPage(num) {
        if (pageRendering) {
            pageNumPending = num;
        } else {
            renderPage(num);
        }
    }

    /**
     * Displays previous page.
     */
    function onPrevPage() {
        if (pageNum <= 1) {
            return;
        }
        pageNum--;
        queueRenderPage(pageNum);
    }

    /**
     * Displays next page.
     */
    function onNextPage() {
        if (pageNum >= pdfDoc.numPages) {
            return;
        }
        pageNum++;
        queueRenderPage(pageNum);
    }

    // Button Events
    document.getElementById('prev-card').addEventListener('click', onPrevPage);
    document.getElementById('next-card').addEventListener('click', onNextPage);

    // Keyboard Events
    document.addEventListener('keydown', (e) => {
        if (cardsScreen.style.display !== 'none') {
            if (e.key === 'ArrowLeft') onPrevPage();
            if (e.key === 'ArrowRight') onNextPage();
        }
    });

    // Swipe Logic
    cardsScreen.addEventListener('touchstart', e => {
        touchStartX = e.changedTouches[0].screenX;
    });

    cardsScreen.addEventListener('touchend', e => {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
    });

    function handleSwipe() {
        const threshold = 50;
        if (touchStartX - touchEndX > threshold) {
            // Swiped Left -> Next Page
            onNextPage();
        }
        if (touchEndX - touchStartX > threshold) {
            // Swiped Right -> Prev Page
            onPrevPage();
        }
    }

    // Load PDF
    function loadPDF() {
        if (pdfDoc) return; // Already loaded

        const url = 'cards/short_deck.pdf';
        pdfjsLib.getDocument(url).promise.then(function (pdfDoc_) {
            pdfDoc = pdfDoc_;
            console.log('PDF loaded, pages:', pdfDoc.numPages);
            renderPage(pageNum);
        }).catch(err => {
            console.error('Error loading PDF:', err);
            // Fallback or error message could go here
        });
    }

    // ------------------------------------------------------------------
    // Initialization
    // ------------------------------------------------------------------

    // Resize handler for PDF rendering
    let pdfResizeHandler = null;

    function setupPDFResizeHandler() {
        // Remove existing handler if any
        if (pdfResizeHandler) {
            window.removeEventListener('resize', pdfResizeHandler);
        }
        // Add new handler
        pdfResizeHandler = () => {
            if (pdfDoc && cardsScreen.style.display !== 'none') {
                renderPage(pageNum);
            }
        };
        window.addEventListener('resize', pdfResizeHandler);
    }

    document.getElementById('nav-cards').addEventListener('click', (e) => {
        e.preventDefault();
        showScreen('cards');
    });
    document.getElementById('bnav-cards').addEventListener('click', (e) => {
        e.preventDefault();
        showScreen('cards');
    });

    // ------------------------------------------------------------------
    // Scheduling Logic
    // ------------------------------------------------------------------

    // Event Data Management with Firestore
    async function saveEventToFirestore(eventData) {
        try {
            const eventRef = db.collection('events').doc();
            const currentUser = auth.currentUser;

            if (!currentUser) {
                throw new Error('User must be authenticated');
            }

            // Calculate geohash if we have coordinates
            let geohashValue = null;
            if (eventData.lat && eventData.lng) {
                geohashValue = ngeohash.encode(eventData.lat, eventData.lng, 7); // precision 7 (~150m)
            }

            const firestoreData = {
                ...eventData,
                geohash: geohashValue,
                createdBy: currentUser.uid,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            };

            await eventRef.set(firestoreData);
            return eventRef.id;
        } catch (error) {
            console.error('Error saving event to Firestore:', error);
            throw error;
        }
    }

    async function updateEventInFirestore(eventId, eventData) {
        try {
            const currentUser = auth.currentUser;
            if (!currentUser) {
                throw new Error('User must be authenticated');
            }

            // Calculate geohash if we have coordinates
            let geohashValue = null;
            if (eventData.lat && eventData.lng) {
                geohashValue = ngeohash.encode(eventData.lat, eventData.lng, 7);
            }

            const updateData = {
                ...eventData,
                geohash: geohashValue,
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            };

            await db.collection('events').doc(eventId).update(updateData);
        } catch (error) {
            console.error('Error updating event in Firestore:', error);
            throw error;
        }
    }

    async function deleteEventFromFirestore(eventId) {
        try {
            await db.collection('events').doc(eventId).delete();
        } catch (error) {
            console.error('Error deleting event from Firestore:', error);
            throw error;
        }
    }

    async function loadEventsFromFirestore() {
        try {
            const snapshot = await db.collection('events')
                .orderBy('date', 'asc')
                .orderBy('time', 'asc')
                .get();

            const events = [];
            snapshot.forEach(doc => {
                events.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
            return events;
        } catch (error) {
            console.error('Error loading events from Firestore:', error);
            return [];
        }
    }

    // ------------------------------------------------------------------
    // RSVP Functions
    // ------------------------------------------------------------------

    async function saveRSVP(eventId, response) {
        try {
            const currentUser = auth.currentUser;
            if (!currentUser) {
                throw new Error('User must be authenticated');
            }

            const displayName = await getCurrentUserDisplayName();
            const rsvpRef = db.collection('rsvps').doc(`${eventId}_${currentUser.uid}`);
            await rsvpRef.set({
                eventId: eventId,
                userId: currentUser.uid,
                displayName: displayName,
                response: response, // 'going', 'maybe', 'not-going'
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            });
        } catch (error) {
            console.error('Error saving RSVP:', error);
            throw error;
        }
    }

    async function getUserRSVP(eventId) {
        try {
            const currentUser = auth.currentUser;
            if (!currentUser) return null;

            const rsvpDoc = await db.collection('rsvps').doc(`${eventId}_${currentUser.uid}`).get();
            if (rsvpDoc.exists) {
                return rsvpDoc.data();
            }
            return null;
        } catch (error) {
            console.error('Error getting user RSVP:', error);
            return null;
        }
    }

    async function getEventRSVPs(eventId) {
        try {
            const snapshot = await db.collection('rsvps')
                .where('eventId', '==', eventId)
                .get();

            const userIds = new Set();
            snapshot.forEach(doc => {
                const data = doc.data();
                if (data && data.userId) {
                    userIds.add(data.userId);
                }
            });
            const nameMap = await getDisplayNamesForUsers([...userIds]);

            const rsvps = {
                going: [],
                maybe: [],
                notGoing: []
            };

            snapshot.forEach(doc => {
                const data = doc.data();
                const displayName = nameMap.get(data.userId) || data.displayName || 'Member';
                const rsvpEntry = { ...data, displayName };
                if (data.response === 'going') {
                    rsvps.going.push(rsvpEntry);
                } else if (data.response === 'maybe') {
                    rsvps.maybe.push(rsvpEntry);
                } else if (data.response === 'not-going') {
                    rsvps.notGoing.push(rsvpEntry);
                }
            });

            return rsvps;
        } catch (error) {
            console.error('Error getting event RSVPs:', error);
            return { going: [], maybe: [], notGoing: [] };
        }
    }

    async function getUserRsvpMap() {
        try {
            const currentUser = auth.currentUser;
            if (!currentUser) return new Map();

            const snapshot = await db.collection('rsvps')
                .where('userId', '==', currentUser.uid)
                .get();

            const map = new Map();
            snapshot.forEach(doc => {
                const data = doc.data();
                if (data && data.eventId) {
                    map.set(data.eventId, data.response);
                }
            });

            return map;
        } catch (error) {
            console.error('Error loading user RSVPs:', error);
            return new Map();
        }
    }

    async function getUpcomingRsvpEvents(limit = 3) {
        try {
            const currentUser = auth.currentUser;
            if (!currentUser) return [];

            const snapshot = await db.collection('rsvps')
                .where('userId', '==', currentUser.uid)
                .get();

            const eventIds = new Set();
            snapshot.forEach(doc => {
                const data = doc.data();
                if (data && data.eventId && (data.response === 'going' || data.response === 'maybe')) {
                    eventIds.add(data.eventId);
                }
            });

            if (eventIds.size === 0) return [];

            const now = new Date();
            const events = await Promise.all([...eventIds].map(async (eventId) => {
                try {
                    const eventDoc = await db.collection('events').doc(eventId).get();
                    if (!eventDoc.exists) return null;
                    const data = eventDoc.data();
                    return { id: eventDoc.id, ...data };
                } catch (error) {
                    console.error('Error loading RSVP event:', error);
                    return null;
                }
            }));

            return events
                .filter(evt => evt)
                .filter(evt => {
                    if (!evt.date) return true;
                    const time = evt.time || '00:00';
                    const eventDate = new Date(`${evt.date}T${time}`);
                    return eventDate >= now;
                })
                .sort((a, b) => {
                    const aTime = new Date(`${a.date}T${a.time || '00:00'}`).getTime();
                    const bTime = new Date(`${b.date}T${b.time || '00:00'}`).getTime();
                    return aTime - bTime;
                })
                .slice(0, limit);
        } catch (error) {
            console.error('Error loading RSVP events:', error);
            return [];
        }
    }

    async function loadMyEventsFromFirestore() {
        try {
            const currentUser = auth.currentUser;
            if (!currentUser) return [];

            const snapshot = await db.collection('events')
                .where('createdBy', '==', currentUser.uid)
                .orderBy('date', 'asc')
                .orderBy('time', 'asc')
                .get();

            const events = [];
            snapshot.forEach(doc => {
                events.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
            return events;
        } catch (error) {
            console.error('Error loading my events from Firestore:', error);
            return [];
        }
    }

    // Cache for events
    let cachedEvents = [];
    let lastEventLoad = 0;
    const EVENT_CACHE_DURATION = 60000; // 1 minute

    async function getAllEvents(forceRefresh = false) {
        const now = Date.now();
        if (!forceRefresh && cachedEvents.length > 0 && (now - lastEventLoad) < EVENT_CACHE_DURATION) {
            return cachedEvents;
        }

        cachedEvents = await loadEventsFromFirestore();
        lastEventLoad = now;
        return cachedEvents;
    }

    // Get upcoming events for a specific group
    async function getEventsForGroup(groupId, limit = 5) {
        try {
            const now = new Date();
            const todayStr = now.toISOString().split('T')[0];

            const snapshot = await db.collection('events')
                .where('groupId', '==', groupId)
                .get();

            const events = [];
            snapshot.forEach(doc => {
                const data = doc.data();
                if (data.date >= todayStr) {
                    events.push({ id: doc.id, ...data });
                }
            });

            // Sort by date and time, take only the next 5
            events.sort((a, b) => {
                const dateA = new Date(a.date + 'T' + a.time);
                const dateB = new Date(b.date + 'T' + b.time);
                return dateA - dateB;
            });

            return events.slice(0, limit);
        } catch (error) {
            console.error('Error fetching group events:', error);
            return [];
        }
    }

    // Get upcoming events from all groups the user is a member of
    async function getEventsFromMyGroups(limit = 5) {
        try {
            const currentUser = auth.currentUser;
            if (!currentUser) return [];

            const groups = await getAllGroups(true);
            const myGroups = groups.filter(g => g.members && g.members.includes(currentUser.uid));

            if (myGroups.length === 0) return [];

            const now = new Date();
            const todayStr = now.toISOString().split('T')[0];

            // Fetch events for all my groups
            const allEvents = [];
            for (const group of myGroups) {
                const snapshot = await db.collection('events')
                    .where('groupId', '==', group.id)
                    .get();

                snapshot.forEach(doc => {
                    const data = doc.data();
                    if (data.date >= todayStr) {
                        allEvents.push({
                            id: doc.id,
                            ...data,
                            groupName: group.name
                        });
                    }
                });
            }

            // Sort by date and time
            allEvents.sort((a, b) => {
                const dateA = new Date(a.date + 'T' + a.time);
                const dateB = new Date(b.date + 'T' + b.time);
                return dateA - dateB;
            });

            return allEvents.slice(0, limit);
        } catch (error) {
            console.error('Error fetching events from my groups:', error);
            return [];
        }
    }

    // ------------------------------------------------------------------
    // Groups Management
    // ------------------------------------------------------------------

    async function createGroupInFirestore(groupData) {
        try {
            const groupRef = db.collection('groups').doc();
            const currentUser = auth.currentUser;

            if (!currentUser) {
                throw new Error('User must be authenticated');
            }

            const firestoreData = {
                name: groupData.name,
                description: groupData.description || '',
                type: groupData.type || 'open', // 'open' or 'closed'
                members: groupData.members || [currentUser.uid],
                admins: groupData.admins || [currentUser.uid],
                createdBy: currentUser.uid,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            };

            // Add location data if provided
            if (groupData.zipCode) {
                firestoreData.zipCode = groupData.zipCode;
                const coords = await geocodeZipCode(groupData.zipCode);
                firestoreData.lat = coords.lat;
                firestoreData.lng = coords.lng;
                firestoreData.geohash = ngeohash.encode(coords.lat, coords.lng, 7);
            }

            await groupRef.set(firestoreData);
            return groupRef.id;
        } catch (error) {
            console.error('Error creating group in Firestore:', error);
            throw error;
        }
    }

    // Join an open group
    async function joinOpenGroup(groupId) {
        try {
            const currentUser = auth.currentUser;
            if (!currentUser) {
                throw new Error('User must be authenticated');
            }

            await db.collection('groups').doc(groupId).update({
                members: firebase.firestore.FieldValue.arrayUnion(currentUser.uid),
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            });
        } catch (error) {
            console.error('Error joining group:', error);
            throw error;
        }
    }

    // Request to join a closed group
    async function requestToJoinGroup(groupId, message = '') {
        try {
            const currentUser = auth.currentUser;
            if (!currentUser) {
                throw new Error('User must be authenticated');
            }

            const requestRef = db.collection('groups').doc(groupId).collection('joinRequests').doc(currentUser.uid);
            const displayName = await getCurrentUserDisplayName();

            await requestRef.set({
                userId: currentUser.uid,
                displayName: displayName,
                message: message,
                status: 'pending',
                createdAt: firebase.firestore.FieldValue.serverTimestamp()
            });
        } catch (error) {
            console.error('Error requesting to join group:', error);
            throw error;
        }
    }

    // Load join requests for a group (admin only)
    async function loadJoinRequests(groupId) {
        try {
            const snapshot = await db.collection('groups').doc(groupId)
                .collection('joinRequests')
                .where('status', '==', 'pending')
                .orderBy('createdAt', 'desc')
                .get();

            const requests = [];
            snapshot.forEach(doc => {
                requests.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
            const missingIds = requests.filter(req => !req.displayName && req.userId).map(req => req.userId);
            if (missingIds.length > 0) {
                const nameMap = await getDisplayNamesForUsers(missingIds);
                requests.forEach(req => {
                    if (!req.displayName && req.userId && nameMap.has(req.userId)) {
                        req.displayName = nameMap.get(req.userId);
                    }
                });
            }
            return requests;
        } catch (error) {
            console.error('Error loading join requests:', error);
            return [];
        }
    }

    // Approve a join request (admin only)
    async function approveJoinRequest(groupId, userId) {
        try {
            // Add user to members
            await db.collection('groups').doc(groupId).update({
                members: firebase.firestore.FieldValue.arrayUnion(userId),
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            });

            // Delete the join request
            await db.collection('groups').doc(groupId).collection('joinRequests').doc(userId).delete();
        } catch (error) {
            console.error('Error approving join request:', error);
            throw error;
        }
    }

    // Reject a join request (admin only)
    async function rejectJoinRequest(groupId, userId) {
        try {
            // Update request status to rejected, then delete
            await db.collection('groups').doc(groupId).collection('joinRequests').doc(userId).delete();
        } catch (error) {
            console.error('Error rejecting join request:', error);
            throw error;
        }
    }

    // Cancel a pending join request (user's own request)
    async function cancelJoinRequest(groupId) {
        try {
            const currentUser = auth.currentUser;
            if (!currentUser) {
                throw new Error('User must be authenticated');
            }

            await db.collection('groups').doc(groupId).collection('joinRequests').doc(currentUser.uid).delete();
        } catch (error) {
            console.error('Error canceling join request:', error);
            throw error;
        }
    }

    // Check if user has a pending join request
    async function checkPendingRequest(groupId) {
        try {
            const currentUser = auth.currentUser;
            if (!currentUser) return null;

            const requestDoc = await db.collection('groups').doc(groupId)
                .collection('joinRequests').doc(currentUser.uid).get();

            if (requestDoc.exists) {
                return requestDoc.data();
            }
            return null;
        } catch (error) {
            console.error('Error checking pending request:', error);
            return null;
        }
    }

    // Promote a member to admin (admin only)
    async function promoteToAdmin(groupId, userId) {
        try {
            await db.collection('groups').doc(groupId).update({
                admins: firebase.firestore.FieldValue.arrayUnion(userId),
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            });
        } catch (error) {
            console.error('Error promoting to admin:', error);
            throw error;
        }
    }

    // Remove admin status from a member (admin only, cannot remove creator)
    async function removeAdmin(groupId, userId) {
        try {
            const groupDoc = await db.collection('groups').doc(groupId).get();
            if (!groupDoc.exists) throw new Error('Group not found');

            const groupData = groupDoc.data();
            if (groupData.createdBy === userId) {
                throw new Error('Cannot remove admin status from the group creator');
            }

            await db.collection('groups').doc(groupId).update({
                admins: firebase.firestore.FieldValue.arrayRemove(userId),
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            });
        } catch (error) {
            console.error('Error removing admin:', error);
            throw error;
        }
    }

    // Remove a member from the group (admin only, cannot remove creator)
    async function removeMember(groupId, userId) {
        try {
            const groupDoc = await db.collection('groups').doc(groupId).get();
            if (!groupDoc.exists) throw new Error('Group not found');

            const groupData = groupDoc.data();
            if (groupData.createdBy === userId) {
                throw new Error('Cannot remove the group creator');
            }

            await db.collection('groups').doc(groupId).update({
                members: firebase.firestore.FieldValue.arrayRemove(userId),
                admins: firebase.firestore.FieldValue.arrayRemove(userId),
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            });
        } catch (error) {
            console.error('Error removing member:', error);
            throw error;
        }
    }

    // Load all groups (for browsing/discovery)
    async function loadAllGroupsForDiscovery() {
        try {
            const snapshot = await db.collection('groups')
                .orderBy('createdAt', 'desc')
                .limit(50)
                .get();

            const groups = [];
            snapshot.forEach(doc => {
                groups.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
            return groups;
        } catch (error) {
            console.error('Error loading all groups:', error);
            return [];
        }
    }

    async function updateGroupInFirestore(groupId, groupData) {
        try {
            const updateData = {
                ...groupData,
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            };

            await db.collection('groups').doc(groupId).update(updateData);
        } catch (error) {
            console.error('Error updating group in Firestore:', error);
            throw error;
        }
    }

    async function leaveGroupInFirestore(groupId) {
        try {
            const currentUser = auth.currentUser;
            if (!currentUser) {
                throw new Error('User must be authenticated');
            }

            await db.collection('groups').doc(groupId).update({
                members: firebase.firestore.FieldValue.arrayRemove(currentUser.uid),
                admins: firebase.firestore.FieldValue.arrayRemove(currentUser.uid),
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            });
        } catch (error) {
            console.error('Error leaving group:', error);
            throw error;
        }
    }

    async function deleteGroupFromFirestore(groupId) {
        try {
            await db.collection('groups').doc(groupId).delete();
        } catch (error) {
            console.error('Error deleting group from Firestore:', error);
            throw error;
        }
    }

    async function loadGroupsFromFirestore() {
        try {
            const currentUser = auth.currentUser;
            if (!currentUser) return [];

            // Load groups where user is creator or member
            const createdSnapshot = await db.collection('groups')
                .where('createdBy', '==', currentUser.uid)
                .get();

            const memberSnapshot = await db.collection('groups')
                .where('members', 'array-contains', currentUser.uid)
                .get();

            const groups = new Map();

            createdSnapshot.forEach(doc => {
                groups.set(doc.id, { id: doc.id, ...doc.data() });
            });

            memberSnapshot.forEach(doc => {
                groups.set(doc.id, { id: doc.id, ...doc.data() });
            });

            return Array.from(groups.values());
        } catch (error) {
            console.error('Error loading groups from Firestore:', error);
            return [];
        }
    }

    async function loadEventsByGroupId(groupId) {
        try {
            const snapshot = await db.collection('events')
                .where('groupId', '==', groupId)
                .orderBy('date', 'asc')
                .orderBy('time', 'asc')
                .get();

            const events = [];
            snapshot.forEach(doc => {
                events.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
            return events;
        } catch (error) {
            console.error('Error loading events by group:', error);
            return [];
        }
    }

    // Cache for groups
    let cachedGroups = [];
    let lastGroupLoad = 0;
    const GROUP_CACHE_DURATION = 60000; // 1 minute

    async function getAllGroups(forceRefresh = false) {
        const now = Date.now();
        if (!forceRefresh && cachedGroups.length > 0 && (now - lastGroupLoad) < GROUP_CACHE_DURATION) {
            return cachedGroups;
        }

        cachedGroups = await loadGroupsFromFirestore();
        lastGroupLoad = now;
        return cachedGroups;
    }

    // Tab Switching
    if (tabFind && tabCreate && tabManage) {
        tabFind.addEventListener('click', () => switchScheduleTab('find'));
        tabManage.addEventListener('click', () => switchScheduleTab('manage'));
        tabCreate.addEventListener('click', () => switchScheduleTab('create'));
    }

    function switchScheduleTab(tab) {
        // Reset Tabs
        [tabFind, tabManage, tabCreate].forEach(t => t.classList.remove('active'));
        [viewFind, viewManage, viewCreate].forEach(v => v.style.display = 'none');

        if (tab === 'find') {
            tabFind.classList.add('active');
            viewFind.style.display = 'block';
            renderEventsAsync();
        } else if (tab === 'manage') {
            tabManage.classList.add('active');
            viewManage.style.display = 'block';
            renderMyEventsAsync();
        } else {
            tabCreate.classList.add('active');
            viewCreate.style.display = 'block';
            // Reset edit state if switching manually to create
            if (editingEventId === null) {
                createEventForm.reset();
                document.querySelector('#view-create button[type="submit"]').textContent = 'Create Event';
            }
            // Populate groups dropdown when switching to create tab
            populateGroupsDropdown();
        }
    }

    // Populate groups dropdown
    async function populateGroupsDropdown() {
        if (!eventGroupSelect) return;

        const groups = await getAllGroups();

        // Clear existing options except the first "No Group" option
        eventGroupSelect.innerHTML = '<option value="">No Group</option>';

        // Add group options
        groups.forEach(group => {
            const option = document.createElement('option');
            option.value = group.id;
            option.textContent = group.name;
            eventGroupSelect.appendChild(option);
        });
    }

    // Groups Tab Elements
    const tabMyGroups = document.getElementById('tab-my-groups');
    const tabBrowseGroups = document.getElementById('tab-browse-groups');
    const tabAdminGroups = document.getElementById('tab-admin-groups');
    const viewMyGroups = document.getElementById('view-my-groups');
    const viewBrowseGroups = document.getElementById('view-browse-groups');
    const viewAdminGroups = document.getElementById('view-admin-groups');
    const browseGroupsContainer = document.getElementById('browse-groups-container');
    const adminGroupsContainer = document.getElementById('admin-groups-container');
    const groupsSearchInput = document.getElementById('groups-search-input');
    const groupsNearMeBtn = document.getElementById('groups-near-me-btn');
    const groupsLocationStatus = document.getElementById('groups-location-status');

    // Browse groups state
    let browseUserLocation = null; // { lat, lng }
    let browseLocationFilter = true; // default: filter by location
    let browseAllGroups = []; // cached browse groups for filtering

    // Groups Tab Switching
    if (tabMyGroups && tabBrowseGroups && tabAdminGroups) {
        tabMyGroups.addEventListener('click', () => switchGroupsTab('my-groups'));
        tabBrowseGroups.addEventListener('click', () => switchGroupsTab('browse-groups'));
        tabAdminGroups.addEventListener('click', () => switchGroupsTab('admin-groups'));
    }

    function switchGroupsTab(tab) {
        // Reset Tabs
        [tabMyGroups, tabBrowseGroups, tabAdminGroups].forEach(t => {
            if (t) t.classList.remove('active');
        });
        [viewMyGroups, viewBrowseGroups, viewAdminGroups].forEach(v => {
            if (v) v.style.display = 'none';
        });

        if (tab === 'my-groups') {
            if (tabMyGroups) tabMyGroups.classList.add('active');
            if (viewMyGroups) viewMyGroups.style.display = 'block';
            renderGroupsList();
        } else if (tab === 'browse-groups') {
            if (tabBrowseGroups) tabBrowseGroups.classList.add('active');
            if (viewBrowseGroups) viewBrowseGroups.style.display = 'block';
            renderBrowseGroups();
        } else if (tab === 'admin-groups') {
            if (tabAdminGroups) tabAdminGroups.classList.add('active');
            if (viewAdminGroups) viewAdminGroups.style.display = 'block';
            renderAdminGroups();
        }
    }

    // Groups search input handler
    if (groupsSearchInput) {
        let searchTimeout = null;
        groupsSearchInput.addEventListener('input', () => {
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => {
                filterAndDisplayBrowseGroups();
            }, 300);
        });
    }

    // Groups Near Me button handler
    if (groupsNearMeBtn) {
        groupsNearMeBtn.addEventListener('click', async () => {
            if (!navigator.geolocation) {
                showMessage('Geolocation is not supported by your browser.', 'error');
                return;
            }

            groupsNearMeBtn.textContent = 'Locating...';
            groupsNearMeBtn.disabled = true;

            try {
                const location = await getUserLocationAsync();
                if (location) {
                    browseUserLocation = location;
                    browseLocationFilter = true;
                    filterAndDisplayBrowseGroups();
                    showMessage('Location found! Showing nearby groups.', 'success');
                } else {
                    showMessage('Unable to retrieve your location.', 'error');
                }
            } finally {
                groupsNearMeBtn.innerHTML = `
                    <svg viewBox="0 0 24 24" width="18" height="18" style="margin-right: 6px;">
                        <path fill="currentColor" d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-7z"/>
                    </svg>
                    Near Me
                `;
                groupsNearMeBtn.disabled = false;
            }
        });
    }

    // Render Groups List (My Groups - groups user is a member of)
    async function renderGroupsList() {
        if (!groupsListContainer) return;

        try {
            groupsListContainer.innerHTML = '<div class="empty-state">Loading groups...</div>';

            const groups = await getAllGroups(true); // Force refresh
            const currentUser = auth.currentUser;

            if (!groups || groups.length === 0) {
                groupsListContainer.innerHTML = '<div class="empty-state">No groups yet. Create your first group!</div>';
                return;
            }

            groupsListContainer.innerHTML = '';
            groups.forEach(group => {
                const card = createGroupCard(group, currentUser, false);
                groupsListContainer.appendChild(card);
            });
        } catch (error) {
            console.error('Error rendering groups list:', error);
            groupsListContainer.innerHTML = '<div class="empty-state">Failed to load groups. Please refresh the page.</div>';
            showMessage('Failed to load groups. Please try again.', 'error');
        }
    }

    // Render Browse Groups (all groups for discovery)
    async function renderBrowseGroups() {
        if (!browseGroupsContainer) return;

        try {
            browseGroupsContainer.innerHTML = '<div class="empty-state">Loading groups...</div>';

            const allGroups = await loadAllGroupsForDiscovery();
            const currentUser = auth.currentUser;

            // Filter out groups user is already a member of
            browseAllGroups = allGroups.filter(group =>
                !group.members || !group.members.includes(currentUser.uid)
            );

            // Try to get user location for default 50-mile filter
            if (!browseUserLocation && browseLocationFilter) {
                browseUserLocation = await getUserLocationAsync();
            }

            filterAndDisplayBrowseGroups();
        } catch (error) {
            console.error('Error rendering browse groups:', error);
            browseGroupsContainer.innerHTML = '<div class="empty-state">Failed to load groups. Please refresh the page.</div>';
            showMessage('Failed to load groups. Please try again.', 'error');
        }
    }

    // Get user location as a promise
    function getUserLocationAsync() {
        return new Promise((resolve) => {
            if (!navigator.geolocation) {
                resolve(null);
                return;
            }
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    resolve({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    });
                },
                () => {
                    resolve(null);
                }
            );
        });
    }

    // Filter and display browse groups based on search text and location
    function filterAndDisplayBrowseGroups() {
        if (!browseGroupsContainer) return;
        const currentUser = auth.currentUser;
        const searchText = groupsSearchInput ? groupsSearchInput.value.trim().toLowerCase() : '';

        let filtered = browseAllGroups;

        // Apply text search filter
        if (searchText) {
            filtered = filtered.filter(group => {
                const name = (group.name || '').toLowerCase();
                const desc = (group.description || '').toLowerCase();
                return name.includes(searchText) || desc.includes(searchText);
            });
        }

        // Apply 50-mile location filter if location is available and filter is active
        if (browseLocationFilter && browseUserLocation) {
            const RADIUS_MILES = 50;
            const nearbyGroups = [];
            const noLocationGroups = [];

            filtered.forEach(group => {
                if (group.lat && group.lng) {
                    const dist = haversineDistance(
                        browseUserLocation.lat, browseUserLocation.lng,
                        group.lat, group.lng
                    );
                    if (dist <= RADIUS_MILES) {
                        group._distance = Math.round(dist);
                        nearbyGroups.push(group);
                    }
                } else {
                    noLocationGroups.push(group);
                }
            });

            // Sort nearby groups by distance
            nearbyGroups.sort((a, b) => a._distance - b._distance);
            filtered = [...nearbyGroups, ...noLocationGroups];

            // Update location status
            if (groupsLocationStatus) {
                groupsLocationStatus.style.display = 'flex';
                groupsLocationStatus.innerHTML = `
                    <span>Showing groups within 50 miles</span>
                    <button id="groups-show-all-btn" class="btn-link" style="margin: 0; padding: 0 0 0 8px; font-size: 0.8125rem;">Show all groups</button>
                `;
                const showAllBtn = document.getElementById('groups-show-all-btn');
                if (showAllBtn) {
                    showAllBtn.addEventListener('click', () => {
                        browseLocationFilter = false;
                        filterAndDisplayBrowseGroups();
                    });
                }
            }
        } else {
            // Location filter is off
            if (groupsLocationStatus) {
                if (browseUserLocation && !browseLocationFilter) {
                    groupsLocationStatus.style.display = 'flex';
                    groupsLocationStatus.innerHTML = `
                        <span>Showing all groups</span>
                        <button id="groups-filter-nearby-btn" class="btn-link" style="margin: 0; padding: 0 0 0 8px; font-size: 0.8125rem;">Filter to nearby</button>
                    `;
                    const filterBtn = document.getElementById('groups-filter-nearby-btn');
                    if (filterBtn) {
                        filterBtn.addEventListener('click', () => {
                            browseLocationFilter = true;
                            filterAndDisplayBrowseGroups();
                        });
                    }
                } else {
                    groupsLocationStatus.style.display = 'none';
                }
            }
        }

        if (!filtered || filtered.length === 0) {
            const msg = searchText
                ? 'No groups match your search.'
                : browseLocationFilter && browseUserLocation
                    ? 'No groups found within 50 miles. Try showing all groups.'
                    : 'No new groups to discover.';
            browseGroupsContainer.innerHTML = `<div class="empty-state">${msg}</div>`;
            return;
        }

        browseGroupsContainer.innerHTML = '';
        filtered.forEach(group => {
            const card = createGroupCard(group, currentUser, true);
            browseGroupsContainer.appendChild(card);
        });
    }

    // Render Admin Groups (groups user is an admin of)
    async function renderAdminGroups() {
        if (!adminGroupsContainer) return;

        try {
            adminGroupsContainer.innerHTML = '<div class="empty-state">Loading groups...</div>';

            const groups = await getAllGroups(true);
            const currentUser = auth.currentUser;

            // Filter to only groups user is an admin of
            const adminGroups = groups.filter(group =>
                group.admins && group.admins.includes(currentUser.uid)
            );

            if (!adminGroups || adminGroups.length === 0) {
                adminGroupsContainer.innerHTML = '<div class="empty-state">You\'re not an admin of any groups yet.</div>';
                return;
            }

            adminGroupsContainer.innerHTML = '';

            // For each admin group, also load pending join requests
            for (const group of adminGroups) {
                const card = await createAdminGroupCard(group, currentUser);
                adminGroupsContainer.appendChild(card);
            }
        } catch (error) {
            console.error('Error rendering admin groups:', error);
            adminGroupsContainer.innerHTML = '<div class="empty-state">Failed to load groups. Please refresh the page.</div>';
            showMessage('Failed to load groups. Please try again.', 'error');
        }
    }

    // Create admin group card with pending request count
    async function createAdminGroupCard(group, currentUser) {
        const card = document.createElement('div');
        card.className = 'group-card admin-group-card';
        card.setAttribute('data-group-id', group.id);

        const memberCount = group.members ? group.members.length : 0;
        const description = group.description || '';
        const groupType = group.type || 'open';

        // Load pending join requests for closed groups
        let pendingCount = 0;
        if (groupType === 'closed') {
            try {
                const requests = await loadJoinRequests(group.id);
                pendingCount = requests.length;
            } catch (e) {
                console.error('Error loading join requests:', e);
            }
        }

        const pendingBadge = pendingCount > 0
            ? `<span class="pending-badge">${pendingCount} pending</span>`
            : '';

        card.innerHTML = `
            <div class="group-card-header">
                <div class="group-info">
                    <h3 class="group-name">${group.name}</h3>
                    ${description ? `<p class="group-description">${description}</p>` : ''}
                    <div class="group-meta">
                        <span class="group-meta-item">
                            <svg viewBox="0 0 24 24" width="16" height="16">
                                <path fill="currentColor" d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
                            </svg>
                            ${memberCount} ${memberCount === 1 ? 'member' : 'members'}
                        </span>
                        <span class="group-badge ${groupType}">${groupType === 'closed' ? 'Closed' : 'Open'}</span>
                        ${pendingBadge}
                    </div>
                </div>
                <div class="group-actions">
                    <button class="btn-sm btn-edit" onclick="window.editGroup('${group.id}')">
                        <svg viewBox="0 0 24 24" width="14" height="14" style="margin-right: 4px;">
                            <path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
                        </svg>
                        Edit
                    </button>
                    <button class="btn-sm btn-manage" onclick="window.manageGroupMembers('${group.id}')">
                        <svg viewBox="0 0 24 24" width="14" height="14" style="margin-right: 4px;">
                            <path fill="currentColor" d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
                        </svg>
                        Members ${pendingCount > 0 ? `(${pendingCount})` : ''}
                    </button>
                </div>
            </div>
        `;

        return card;
    }

    function createGroupCard(group, currentUser, isDiscoveryView = false) {
        const card = document.createElement('div');
        card.className = 'group-card';
        card.setAttribute('data-group-id', group.id);

        const isAdmin = group.admins && group.admins.includes(currentUser.uid);
        const isCreator = group.createdBy === currentUser.uid;
        const isMember = group.members && group.members.includes(currentUser.uid);

        // Make card clickable to show events
        if (isMember) {
            card.style.cursor = 'pointer';
            card.addEventListener('click', (e) => {
                // Don't trigger if clicking on a button
                if (e.target.tagName === 'BUTTON' || e.target.closest('button')) {
                    return;
                }
                window.showGroupEvents(group.id, group.name);
            });
        }
        const memberCount = group.members ? group.members.length : 0;
        const groupType = group.type || 'open';
        const description = group.description || '';

        let actionsHtml = '';

        if (isMember) {
            // User is a member
            if (isAdmin || isCreator) {
                actionsHtml = `
                    <button class="btn-sm btn-edit" onclick="window.editGroup('${group.id}')">
                        <svg viewBox="0 0 24 24" width="14" height="14" style="margin-right: 4px;">
                            <path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
                        </svg>
                        Edit
                    </button>
                    <button class="btn-sm btn-manage" onclick="window.manageGroupMembers('${group.id}')">
                        <svg viewBox="0 0 24 24" width="14" height="14" style="margin-right: 4px;">
                            <path fill="currentColor" d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
                        </svg>
                        Members
                    </button>
                `;
            }

            if (!isCreator) {
                actionsHtml += `
                    <button class="btn-sm btn-leave" onclick="window.leaveGroup('${group.id}', '${group.name.replace(/'/g, "\\'")}')">
                        <svg viewBox="0 0 24 24" width="14" height="14" style="margin-right: 4px;">
                            <path fill="currentColor" d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
                        </svg>
                        Leave
                    </button>
                `;
            }
        } else if (isDiscoveryView) {
            // User is not a member, show join options
            if (groupType === 'open') {
                actionsHtml = `
                    <button class="btn-sm btn-join" onclick="window.joinGroup('${group.id}')">
                        <svg viewBox="0 0 24 24" width="14" height="14" style="margin-right: 4px;">
                            <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
                        </svg>
                        Join
                    </button>
                `;
            } else {
                actionsHtml = `
                    <button class="btn-sm btn-request" onclick="window.requestJoinGroup('${group.id}', '${group.name.replace(/'/g, "\\'")}')">
                        <svg viewBox="0 0 24 24" width="14" height="14" style="margin-right: 4px;">
                            <path fill="currentColor" d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                        </svg>
                        Request to Join
                    </button>
                `;
            }
        }

        // Build type badge
        const typeBadge = groupType === 'closed'
            ? '<span class="group-badge closed">Closed</span>'
            : '<span class="group-badge open">Open</span>';

        // Build role badge for members
        let roleBadge = '';
        if (isMember) {
            roleBadge = isAdmin ? '<span class="group-badge admin">Admin</span>' : '<span class="group-badge member">Member</span>';
        }

        // Build location info
        let locationHtml = '';
        if (group.zipCode) {
            locationHtml = `
                <span class="group-meta-item group-location-info">
                    <svg viewBox="0 0 24 24" width="16" height="16">
                        <path fill="currentColor" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                    </svg>
                    ${group.zipCode}
                </span>
            `;
        }

        // Build distance badge (set during browse filtering)
        let distanceHtml = '';
        if (typeof group._distance === 'number') {
            distanceHtml = `<span class="group-distance">${group._distance} mi</span>`;
        }

        card.innerHTML = `
            <div class="group-card-header">
                <div class="group-info">
                    <h3 class="group-name">${group.name}</h3>
                    ${description ? `<p class="group-description">${description}</p>` : ''}
                    <div class="group-meta">
                        <span class="group-meta-item">
                            <svg viewBox="0 0 24 24" width="16" height="16">
                                <path fill="currentColor" d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
                            </svg>
                            ${memberCount} ${memberCount === 1 ? 'member' : 'members'}
                        </span>
                        ${locationHtml}
                        ${typeBadge}
                        ${roleBadge}
                        ${distanceHtml}
                    </div>
                </div>
                <div class="group-actions">
                    ${actionsHtml}
                </div>
            </div>
        `;

        return card;
    }

    // Window functions for group actions
    window.editGroup = async (groupId) => {
        try {
            const groupDoc = await db.collection('groups').doc(groupId).get();
            if (!groupDoc.exists) {
                showMessage("Group not found.", "error");
                return;
            }

            const group = groupDoc.data();
            editingGroupId = groupId;

            document.getElementById('group-name').value = group.name;
            document.getElementById('group-description').value = group.description || '';
            document.getElementById('group-type').value = group.type || 'open';
            const groupZipInput = document.getElementById('group-zip');
            if (groupZipInput) groupZipInput.value = group.zipCode || '';
            groupModalTitle.textContent = 'Edit Group';
            submitGroupBtn.textContent = 'Update Group';

            // Show all sections when editing
            if (groupAdminsSection) {
                groupAdminsSection.style.display = 'none'; // Keep hidden - use member management instead
            }

            groupModalInstance.open();
        } catch (error) {
            console.error('Error loading group:', error);
            showMessage("Error loading group: " + error.message, "error");
        }
    };

    window.leaveGroup = async (groupId, groupName) => {
        const confirmed = await confirmDialog(`Are you sure you want to leave "${groupName}"?`, 'Leave Group');
        if (!confirmed) return;

        try {
            await leaveGroupInFirestore(groupId);
            cachedGroups = []; // Clear cache
            await renderGroupsList();
            await populateGroupsDropdown(); // Update dropdown
            showMessage("Left group successfully.", "success");
        } catch (error) {
            console.error('Error leaving group:', error);
            showMessage("Error leaving group: " + error.message, "error");
        }
    };

    // Join an open group
    window.joinGroup = async (groupId) => {
        try {
            await joinOpenGroup(groupId);
            cachedGroups = []; // Clear cache
            await renderGroupsList();
            await populateGroupsDropdown();
            showMessage("Joined group successfully!", "success");
        } catch (error) {
            console.error('Error joining group:', error);
            showMessage("Error joining group: " + error.message, "error");
        }
    };

    // Request to join a closed group
    window.requestJoinGroup = async (groupId, groupName) => {
        const message = await promptDialog(`Optionally enter a message for the admins:`, `Request to join "${groupName}"`, '', 'Hi, I\'d like to join...');
        if (message === null) return; // User cancelled

        try {
            await requestToJoinGroup(groupId, message);
            showMessage("Join request sent! An admin will review your request.", "success");
            await renderGroupsList();
        } catch (error) {
            console.error('Error requesting to join:', error);
            showMessage("Error sending join request: " + error.message, "error");
        }
    };

    // Cancel a pending join request
    window.cancelJoinRequest = async (groupId) => {
        const confirmed = await confirmDialog('Cancel your join request?', 'Cancel Request');
        if (!confirmed) return;

        try {
            await cancelJoinRequest(groupId);
            showMessage("Join request cancelled.", "success");
            await renderGroupsList();
        } catch (error) {
            console.error('Error canceling request:', error);
            showMessage("Error canceling request: " + error.message, "error");
        }
    };

    // Manage group members (admin view)
    window.manageGroupMembers = async (groupId) => {
        try {
            const groupDoc = await db.collection('groups').doc(groupId).get();
            if (!groupDoc.exists) {
                showMessage("Group not found.", "error");
                return;
            }

            const group = groupDoc.data();
            group.id = groupId;
            const currentUser = auth.currentUser;

            // Check if user is admin
            if (!group.admins.includes(currentUser.uid)) {
                showMessage("You must be an admin to manage members.", "error");
                return;
            }

            // Load join requests if closed group
            let joinRequests = [];
            if (group.type === 'closed') {
                joinRequests = await loadJoinRequests(groupId);
            }

            // Show member management modal
            await showMemberManagementModal(group, joinRequests);
        } catch (error) {
            console.error('Error loading group for management:', error);
            showMessage("Error loading group: " + error.message, "error");
        }
    };

    // Approve join request
    window.approveRequest = async (groupId, userId, displayName) => {
        const confirmed = await confirmDialog(`Approve ${displayName}'s request to join?`, 'Approve Request');
        if (!confirmed) return;

        try {
            await approveJoinRequest(groupId, userId);
            cachedGroups = [];
            showMessage(`${displayName} has been added to the group.`, "success");
            // Refresh the modal
            await window.manageGroupMembers(groupId);
        } catch (error) {
            console.error('Error approving request:', error);
            showMessage("Error approving request: " + error.message, "error");
        }
    };

    // Reject join request
    window.rejectRequest = async (groupId, userId, displayName) => {
        const confirmed = await confirmDialog(`Reject ${displayName}'s request to join?`, 'Reject Request');
        if (!confirmed) return;

        try {
            await rejectJoinRequest(groupId, userId);
            showMessage(`${displayName}'s request has been rejected.`, "success");
            await window.manageGroupMembers(groupId);
        } catch (error) {
            console.error('Error rejecting request:', error);
            showMessage("Error rejecting request: " + error.message, "error");
        }
    };

    // Promote member to admin
    window.promoteMember = async (groupId, userId, displayName) => {
        const confirmed = await confirmDialog(`Make ${displayName} an admin?`, 'Promote to Admin');
        if (!confirmed) return;

        try {
            await promoteToAdmin(groupId, userId);
            cachedGroups = [];
            showMessage(`${displayName} is now an admin.`, "success");
            await window.manageGroupMembers(groupId);
        } catch (error) {
            console.error('Error promoting member:', error);
            showMessage("Error promoting member: " + error.message, "error");
        }
    };

    // Remove admin status
    window.demoteMember = async (groupId, userId, displayName) => {
        const confirmed = await confirmDialog(`Remove admin status from ${displayName}?`, 'Remove Admin');
        if (!confirmed) return;

        try {
            await removeAdmin(groupId, userId);
            cachedGroups = [];
            showMessage(`${displayName} is no longer an admin.`, "success");
            await window.manageGroupMembers(groupId);
        } catch (error) {
            console.error('Error demoting member:', error);
            showMessage("Error removing admin status: " + error.message, "error");
        }
    };

    // Remove member from group
    window.kickMember = async (groupId, userId, displayName) => {
        const confirmed = await confirmDialog(`Remove ${displayName} from the group?`, 'Remove Member');
        if (!confirmed) return;

        try {
            await removeMember(groupId, userId);
            cachedGroups = [];
            showMessage(`${displayName} has been removed from the group.`, "success");
            await window.manageGroupMembers(groupId);
        } catch (error) {
            console.error('Error removing member:', error);
            showMessage("Error removing member: " + error.message, "error");
        }
    };

    // Show group events modal
    window.showGroupEvents = async (groupId, groupName) => {
        const modal = document.getElementById('group-events-modal');
        const title = document.getElementById('group-events-title');
        const eventsList = document.getElementById('group-events-list');
        const closeBtn = document.getElementById('close-group-events-modal');

        title.textContent = `Upcoming Events - ${groupName}`;
        eventsList.innerHTML = '<div class="empty-state">Loading events...</div>';
        groupEventsModalInstance.open();

        try {
            const events = await getEventsForGroup(groupId, 5);

            if (events.length === 0) {
                eventsList.innerHTML = '<div class="empty-state">No upcoming events for this group.</div>';
                return;
            }

            eventsList.innerHTML = '';
            events.forEach(evt => {
                const eventCard = document.createElement('div');
                eventCard.className = 'event-card';
                eventCard.style.marginBottom = '10px';

                const eventDate = new Date(evt.date + 'T' + evt.time);
                const formattedDate = eventDate.toLocaleDateString('en-US', {
                    weekday: 'short',
                    month: 'short',
                    day: 'numeric'
                });

                eventCard.innerHTML = `
                    <div class="event-card-header">
                        <h4 style="margin: 0 0 8px 0;">${evt.title}</h4>
                        <div class="event-details">
                            <span class="event-detail-item">
                                <svg viewBox="0 0 24 24" width="16" height="16">
                                    <path fill="currentColor" d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
                                    <path fill="currentColor" d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                                </svg>
                                ${formattedDate} at ${evt.time}
                            </span>
                            <span class="event-detail-item">
                                <svg viewBox="0 0 24 24" width="16" height="16">
                                    <path fill="currentColor" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"/>
                                </svg>
                                ${evt.location}
                            </span>
                        </div>
                    </div>
                `;
                eventsList.appendChild(eventCard);
            });
        } catch (error) {
            console.error('Error loading group events:', error);
            eventsList.innerHTML = '<div class="empty-state">Failed to load events.</div>';
        }
    };

    // Show member management modal
    async function showMemberManagementModal(group, joinRequests) {
        const currentUser = auth.currentUser;
        const isCreator = group.createdBy === currentUser.uid;

        // Build join requests section
        let requestsHtml = '';
        if (group.type === 'closed' && joinRequests.length > 0) {
            requestsHtml = `
                <div class="member-section">
                    <h4>Pending Join Requests (${joinRequests.length})</h4>
                    <div class="members-list">
                        ${joinRequests.map(req => {
                            const name = req.displayName || 'Member';
                            const safeName = name.replace(/'/g, "\\'");
                            return `
                                <div class="member-row">
                                    <div class="member-info">
                                        <span class="member-email">${name}</span>
                                        ${req.message ? `<span class="member-message">"${req.message}"</span>` : ''}
                                    </div>
                                    <div class="member-actions">
                                        <button class="btn-sm btn-approve" onclick="window.approveRequest('${group.id}', '${req.userId}', '${safeName}')">Approve</button>
                                        <button class="btn-sm btn-reject" onclick="window.rejectRequest('${group.id}', '${req.userId}', '${safeName}')">Reject</button>
                                    </div>
                                </div>
                            `;
                        }).join('')}
                    </div>
                </div>
            `;
        } else if (group.type === 'closed') {
            requestsHtml = `
                <div class="member-section">
                    <h4>Pending Join Requests</h4>
                    <p class="empty-state-small">No pending requests</p>
                </div>
            `;
        }

        // Build members list
        const memberNames = await getDisplayNamesForUsers(group.members || []);
        const membersHtml = (group.members || []).map(memberId => {
            const isAdmin = group.admins.includes(memberId);
            const isMemberCreator = group.createdBy === memberId;
            const isSelf = memberId === currentUser.uid;

            const displayName = memberId === currentUser.uid ? 'You' : (memberNames.get(memberId) || 'Member');
            const safeName = displayName.replace(/'/g, "\\'");

            let actionButtons = '';
            if (!isSelf && !isMemberCreator) {
                if (isAdmin) {
                    actionButtons += `<button class="btn-icon" onclick="window.demoteMember('${group.id}', '${memberId}', '${safeName}')" title="Remove Admin">
                        <svg viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"/></svg>
                    </button>`;
                } else {
                    actionButtons += `<button class="btn-icon" onclick="window.promoteMember('${group.id}', '${memberId}', '${safeName}')" title="Make Admin">
                        <svg viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/></svg>
                    </button>`;
                }
                actionButtons += `<button class="btn-icon danger" onclick="window.kickMember('${group.id}', '${memberId}', '${safeName}')" title="Remove Member">
                    <svg viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
                </button>`;
            }

            return `
                <div class="member-row">
                    <div class="member-info">
                        <span class="member-email">${displayName}</span>
                        <span class="member-role-badge ${isAdmin ? 'admin' : ''} ${isMemberCreator ? 'creator' : ''}">
                            ${isMemberCreator ? 'Creator' : (isAdmin ? 'Admin' : 'Member')}
                        </span>
                    </div>
                    <div class="member-actions">
                        ${actionButtons}
                    </div>
                </div>
            `;
        }).join('');

        // Create and show modal
        const modalHtml = `
            <div id="member-modal" class="modal" style="display: none;">
                <div class="modal-content member-modal-content">
                    <div class="modal-header">
                        <h3>Manage Members - ${group.name}</h3>
                        <button class="modal-close">&times;</button>
                    </div>
                    <div class="modal-body">
                        ${requestsHtml}
                        <div class="member-section">
                            <h4>Members (${group.members.length})</h4>
                            <div class="members-list">
                                ${membersHtml}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;

        // Remove existing modal if present
        const existingModal = document.getElementById('member-modal');
        if (existingModal) existingModal.remove();

        // Add modal to DOM
        document.body.insertAdjacentHTML('beforeend', modalHtml);

        // Initialize Modal
        const memberModalInstance = new Modal('member-modal', {
            onClose: () => {
                const el = document.getElementById('member-modal');
                if (el) el.remove();
                memberModalInstance.destroy(); // cleanup listener
            }
        });
        memberModalInstance.open();
    }

    // Group Modal Instance
    const groupModalInstance = new Modal(groupModal, {
        onClose: () => {
            createGroupForm.reset();
            editingGroupId = null;
        }
    });

    // Group Events Modal Instance
    const groupEventsModalInstance = new Modal('group-events-modal', {
        onClose: () => {
            document.getElementById('group-events-list').innerHTML = '<div class="empty-state">Loading events...</div>';
        }
    });

    // Event RSVPs Modal Instance
    const eventRsvpsModalInstance = new Modal('event-rsvps-modal', {
        onClose: () => {
            document.getElementById('event-rsvps-content').innerHTML = '<div class="empty-state">Loading RSVPs...</div>';
        }
    });

    // Group Modal Handlers
    if (createNewGroupLink) {
        createNewGroupLink.addEventListener('click', () => {
            editingGroupId = null;
            createGroupForm.reset();
            groupModalTitle.textContent = 'Create New Group';
            submitGroupBtn.textContent = 'Create Group';
            if (groupAdminsSection) groupAdminsSection.style.display = 'none';
            groupModalInstance.open();
        });
    }

    if (createGroupBtn) {
        createGroupBtn.addEventListener('click', () => {
            editingGroupId = null;
            createGroupForm.reset();
            groupModalTitle.textContent = 'Create New Group';
            submitGroupBtn.textContent = 'Create Group';
            if (groupAdminsSection) groupAdminsSection.style.display = 'none';
            groupModalInstance.open();
        });
    }

    if (cancelGroupModal) {
        cancelGroupModal.addEventListener('click', () => {
            groupModalInstance.close();
        });
    }

    // Create/Edit Group Form Handler
    if (createGroupForm) {
        createGroupForm.addEventListener('submit', async (e) => {
            e.preventDefault();

            const groupName = document.getElementById('group-name').value.trim();
            const groupDescription = document.getElementById('group-description')?.value.trim() || '';
            const groupType = document.getElementById('group-type')?.value || 'open';
            const groupZip = document.getElementById('group-zip')?.value.trim() || '';

            if (!groupName) {
                showMessage('Please enter a group name', 'error');
                return;
            }

            try {
                if (editingGroupId) {
                    // Update existing group
                    const updateData = {
                        name: groupName,
                        description: groupDescription,
                        type: groupType
                    };
                    if (groupZip) {
                        updateData.zipCode = groupZip;
                        const coords = await geocodeZipCode(groupZip);
                        updateData.lat = coords.lat;
                        updateData.lng = coords.lng;
                        updateData.geohash = ngeohash.encode(coords.lat, coords.lng, 7);
                    }
                    await updateGroupInFirestore(editingGroupId, updateData);
                    showMessage('Group updated successfully!', 'success');
                } else {
                    // Create new group
                    await createGroupInFirestore({
                        name: groupName,
                        description: groupDescription,
                        type: groupType,
                        zipCode: groupZip
                    });
                    showMessage('Group created successfully!', 'success');
                }

                cachedGroups = []; // Clear cache
                await populateGroupsDropdown();

                // If on groups screen, refresh the list
                if (groupsScreen && groupsScreen.style.display === 'block') {
                    await renderGroupsList();
                }

                groupModalInstance.close();
            } catch (error) {
                showMessage('Error saving group: ' + error.message, 'error');
            }
        });
    }

    // Async render wrapper
    async function renderEventsAsync() {
        try {
            const events = await getAllEvents();
            await renderEvents(events);
        } catch (error) {
            console.error('Error rendering events:', error);
            showMessage('Failed to load events. Please try again.', 'error');
            eventsList.innerHTML = '<div class="empty-state">Failed to load events. Please refresh the page.</div>';
        }
    }

    async function renderMyEventsAsync() {
        try {
            await renderMyEvents();
        } catch (error) {
            console.error('Error rendering my events:', error);
            showMessage('Failed to load your events. Please try again.', 'error');
            myEventsList.innerHTML = '<div class="empty-state">Failed to load your events. Please refresh the page.</div>';
        }
    }

    async function renderEvents(events) {
        // Render List
        eventsList.innerHTML = '';
        if (events.length === 0) {
            eventsList.innerHTML = '<div class="empty-state">No events found matching your criteria.</div>';
        } else {
            for (const evt of events) {
                const card = await createEventCard(evt);
                eventsList.appendChild(card);
            }
        }

        // Update Map Markers if map is initialized
        if (mapInstance) {
            updateMapMarkers(events);
        }
    }

    // Map & View Toggle Logic
    window.toggleEventView = async (view) => {
        currentView = view;
        if (view === 'list') {
            btnViewList.classList.add('active');
            btnViewMap.classList.remove('active');
            eventsList.style.display = 'block';
            eventsMapContainer.style.display = 'none';
        } else {
            btnViewList.classList.remove('active');
            btnViewMap.classList.add('active');
            eventsList.style.display = 'none';
            eventsMapContainer.style.display = 'block';

            if (!mapInstance) {
                initMap();
            }
            // Leaflet requires a resize trigger when container becomes visible
            setTimeout(async () => {
                mapInstance.invalidateSize();
                const allEvents = await getAllEvents();
                updateMapMarkers(allEvents); // Ensure markers are shown
            }, 100);
        }
    };

    async function initMap() {
        // Centered on SF for demo
        mapInstance = L.map('events-map-container').setView([37.7749, -122.4194], 12);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; OpenStreetMap contributors'
        }).addTo(mapInstance);

        // Initial populate
        const allEvents = await getAllEvents();
        updateMapMarkers(allEvents);
    }

    function updateMapMarkers(events) {
        if (!mapInstance) return;

        // Clear existing
        mapMarkers.forEach(m => mapInstance.removeLayer(m));
        mapMarkers = [];

        events.forEach(evt => {
            // Use coords if available, or skip/randomize (skipping for now)
            if (evt.lat && evt.lng) {
                const marker = L.marker([evt.lat, evt.lng])
                    .addTo(mapInstance)
                    .bindPopup(`<b>${evt.title}</b><br>${evt.time}`);
                mapMarkers.push(marker);
            }
        });
    }

    async function renderMyEvents() {
        // Render user's own events
        myEventsList.innerHTML = '<div class="empty-state">Loading your events...</div>';

        const myEvents = await loadMyEventsFromFirestore();

        if (myEvents.length === 0) {
            myEventsList.innerHTML = '<div class="empty-state">You haven\'t created any events yet.</div>';
            return;
        }

        myEventsList.innerHTML = '';
        for (const evt of myEvents) {
            const card = await createEventCard(evt, true); // true = isOwner
            myEventsList.appendChild(card);
        }

        // Render upcoming RSVP events
        if (myRsvpsList) {
            myRsvpsList.innerHTML = '<div class="empty-state">Loading your RSVPs...</div>';
            const rsvpEvents = await getUpcomingRsvpEvents(3);
            if (rsvpEvents.length === 0) {
                myRsvpsList.innerHTML = '<div class="empty-state">You haven\'t RSVP\'d to any upcoming events yet.</div>';
            } else {
                myRsvpsList.innerHTML = '';
                for (const evt of rsvpEvents) {
                    const card = await createEventCard(evt, false);
                    myRsvpsList.appendChild(card);
                }
            }
        }

        // Render group events section (exclude events already RSVP'd to)
        const groupEventsSection = document.getElementById('group-events-section');
        if (groupEventsSection) {
            groupEventsSection.innerHTML = '<div class="empty-state">Loading group events...</div>';

            const [groupEvents, rsvpMap] = await Promise.all([
                getEventsFromMyGroups(5),
                getUserRsvpMap()
            ]);

            const filteredEvents = groupEvents.filter(evt => !rsvpMap.has(evt.id));

            if (filteredEvents.length === 0) {
                groupEventsSection.innerHTML = '<div class="empty-state">No new upcoming events from your groups.</div>';
            } else {
                groupEventsSection.innerHTML = '';
                for (const evt of filteredEvents) {
                    const card = await createEventCard(evt, false);
                    // Add group name badge if available
                    if (evt.groupName) {
                        const groupBadge = document.createElement('div');
                        groupBadge.className = 'event-group-badge';
                        groupBadge.style.fontSize = '12px';
                        groupBadge.style.color = 'var(--primary)';
                        groupBadge.style.marginTop = '8px';
                        groupBadge.style.paddingTop = '8px';
                        groupBadge.style.borderTop = '1px solid var(--border)';
                        groupBadge.innerHTML = `<strong>Group:</strong> ${evt.groupName}`;
                        card.appendChild(groupBadge);
                    }
                    groupEventsSection.appendChild(card);
                }
            }
        }
    }

    async function createEventCard(evt, isOwner = false) {
        const card = document.createElement('div');
        card.className = 'event-card';

        let actionsHtml = '';
        if (isOwner) {
            actionsHtml = `
                <div class="event-actions">
                    <button class="btn-sm btn-primary" onclick="window.viewEventRSVPs('${evt.id}', '${evt.title.replace(/'/g, "\\'")}')">
                         <svg viewBox="0 0 24 24" width="14" height="14"><path fill="currentColor" d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/></svg>
                         View RSVPs
                    </button>
                    <button class="btn-sm btn-secondary" onclick="window.launchSessionFromEvent('${evt.id}', '${evt.title.replace(/'/g, "\\'")}')">
                        <svg viewBox="0 0 24 24" width="14" height="14"><path fill="currentColor" d="M12 2a7 7 0 00-7 7v4H3l3.5 3.5L10 13H7V9a5 5 0 0110 0v4h-3l3.5 3.5L21 13h-2V9a7 7 0 00-7-7z"/></svg>
                        Start Session
                    </button>
                    <button class="btn-sm btn-edit" onclick="window.editEvent('${evt.id}')">
                         <svg viewBox="0 0 24 24" width="14" height="14"><path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/></svg>
                         Edit
                    </button>
                    <button class="btn-sm btn-delete" onclick="window.deleteEvent('${evt.id}')">
                        <svg viewBox="0 0 24 24" width="14" height="14"><path fill="currentColor" d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
                        Delete
                    </button>
                </div>
            `;
        } else {
            // For non-owners, show RSVP buttons
            const userRsvp = await getUserRSVP(evt.id);
            const currentRsvp = userRsvp ? userRsvp.response : null;

            const rsvpButtons = `
                <div class="event-rsvp-actions" style="margin-top: 12px; display: flex; gap: 8px; flex-wrap: wrap;">
                    <button class="btn-sm ${currentRsvp === 'going' ? 'btn-primary' : 'btn-secondary'}"
                            onclick="window.rsvpToEvent('${evt.id}', 'going')"
                            style="flex: 1; min-width: 80px;">
                        ✓ Going
                    </button>
                    <button class="btn-sm ${currentRsvp === 'maybe' ? 'btn-primary' : 'btn-secondary'}"
                            onclick="window.rsvpToEvent('${evt.id}', 'maybe')"
                            style="flex: 1; min-width: 80px;">
                        ? Maybe
                    </button>
                    <button class="btn-sm ${currentRsvp === 'not-going' ? 'btn-primary' : 'btn-secondary'}"
                            onclick="window.rsvpToEvent('${evt.id}', 'not-going')"
                            style="flex: 1; min-width: 80px;">
                        ✗ Can't Go
                    </button>
                </div>
            `;
            actionsHtml = rsvpButtons;
        }

        card.innerHTML = `
            <div class="event-header">
                <h4 class="event-title">${evt.title}</h4>
                <span class="event-time">${formatTime(evt.time)}</span>
            </div>
            <div class="event-details">
                <span class="event-detail-item">
                    <svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z"/></svg>
                    ${new Date(evt.date).toLocaleDateString()}
                </span>
                <span class="event-detail-item">
                    <svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"/></svg>
                    ${evt.location}
                </span>
            </div>
            ${actionsHtml}
        `;
        return card;
    }

    // RSVP to event
    window.rsvpToEvent = async (eventId, response) => {
        try {
            await saveRSVP(eventId, response);
            showMessage("RSVP updated!", "success");
            // Refresh the events to show updated RSVP status
            await renderMyEvents();
            const allEvents = await getAllEvents(true);
            await renderEvents(allEvents);
        } catch (error) {
            console.error('Error saving RSVP:', error);
            showMessage("Error saving RSVP: " + error.message, "error");
        }
    };

    // View event RSVPs (for event owners)
    window.viewEventRSVPs = async (eventId, eventTitle) => {
        const modal = document.getElementById('event-rsvps-modal');
        const title = document.getElementById('event-rsvps-title');
        const content = document.getElementById('event-rsvps-content');
        const closeBtn = document.getElementById('close-event-rsvps-modal');

        title.textContent = `RSVPs - ${eventTitle}`;
        content.innerHTML = '<div class="empty-state">Loading RSVPs...</div>';
        eventRsvpsModalInstance.open();

        try {
            const rsvps = await getEventRSVPs(eventId);

            const totalRsvps = rsvps.going.length + rsvps.maybe.length + rsvps.notGoing.length;

            if (totalRsvps === 0) {
                content.innerHTML = '<div class="empty-state">No RSVPs yet.</div>';
                return;
            }

            let html = `
                <div style="margin-bottom: 20px;">
                    <strong>Summary:</strong> ${rsvps.going.length} Going, ${rsvps.maybe.length} Maybe, ${rsvps.notGoing.length} Can't Go
                </div>
            `;

            if (rsvps.going.length > 0) {
                html += `
                    <div style="margin-bottom: 20px;">
                        <h4 style="color: var(--success); margin-bottom: 10px;">✓ Going (${rsvps.going.length})</h4>
                        <ul style="list-style: none; padding: 0;">
                            ${rsvps.going.map(r => `<li style="padding: 5px 0;">${r.displayName || 'Member'}</li>`).join('')}
                        </ul>
                    </div>
                `;
            }

            if (rsvps.maybe.length > 0) {
                html += `
                    <div style="margin-bottom: 20px;">
                        <h4 style="color: var(--warning); margin-bottom: 10px;">? Maybe (${rsvps.maybe.length})</h4>
                        <ul style="list-style: none; padding: 0;">
                            ${rsvps.maybe.map(r => `<li style="padding: 5px 0;">${r.displayName || 'Member'}</li>`).join('')}
                        </ul>
                    </div>
                `;
            }

            if (rsvps.notGoing.length > 0) {
                html += `
                    <div style="margin-bottom: 20px;">
                        <h4 style="color: var(--text-secondary); margin-bottom: 10px;">✗ Can't Go (${rsvps.notGoing.length})</h4>
                        <ul style="list-style: none; padding: 0;">
                            ${rsvps.notGoing.map(r => `<li style="padding: 5px 0;">${r.displayName || 'Member'}</li>`).join('')}
                        </ul>
                    </div>
                `;
            }

            content.innerHTML = html;
        } catch (error) {
            console.error('Error loading RSVPs:', error);
            content.innerHTML = '<div class="empty-state">Failed to load RSVPs.</div>';
        }
    };

    // Launch session moderation from event RSVPs
    window.launchSessionFromEvent = async (eventId, eventTitle) => {
        try {
            navigateTo('sessions');
            const rsvps = await getEventRSVPs(eventId);
            const names = extractParticipantNamesFromRsvps(rsvps);

            prefillSessionParticipants({
                names,
                setParticipants: (next) => { participants = next; },
                renderParticipants,
                updateOrganizeButton,
                groupsDisplay,
                participantNameInput,
                showMessage,
                eventTitle
            });
        } catch (error) {
            console.error('Error launching session from event:', error);
            showMessage('Failed to load RSVPs for this session.', 'error');
        }
    };

    // Expose functions to window for onclick handlers
    window.deleteEvent = async (id) => {
        const confirmed = await confirmDialog('Are you sure you want to delete this event?', 'Delete Event');
        if (!confirmed) return;

        try {
            await deleteEventFromFirestore(id);
            cachedEvents = []; // Clear cache
            await renderMyEvents();
            showMessage("Event deleted.", "success");
        } catch (error) {
            console.error('Error deleting event:', error);
            showMessage("Error deleting event: " + error.message, "error");
        }
    };

    window.editEvent = async (id) => {
        try {
            const eventDoc = await db.collection('events').doc(id).get();
            if (!eventDoc.exists) {
                showMessage("Event not found.", "error");
                return;
            }

            const evt = eventDoc.data();
            editingEventId = id;
            document.getElementById('evt-title').value = evt.title;
            document.getElementById('evt-date').value = evt.date;
            document.getElementById('evt-time').value = evt.time;
            document.getElementById('evt-location').value = evt.location;

            // Populate group dropdown and select the event's group
            await populateGroupsDropdown();
            if (evt.groupId && eventGroupSelect) {
                eventGroupSelect.value = evt.groupId;
            }

            // Set openTo field
            const openToSelect = document.getElementById('evt-open-to');
            if (openToSelect && evt.openTo) {
                openToSelect.value = evt.openTo;
            }

            document.querySelector('#view-create button[type="submit"]').textContent = 'Update Event';
            switchScheduleTab('create');
        } catch (error) {
            console.error('Error loading event:', error);
            showMessage("Error loading event: " + error.message, "error");
        }
    };

    function formatTime(timeStr) {
        const [hours, minutes] = timeStr.split(':');
        return new Date(0, 0, 0, hours, minutes).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
    }

    // Search Logic
    if (btnSearchZip) {
        btnSearchZip.addEventListener('click', async () => {
            const zip = inputZip.value.trim();
            if (!zip) return;
            const allEvents = await getAllEvents(true); // force refresh
            const filtered = allEvents.filter(e => e.location === zip);
            await renderEvents(filtered);
        });
    }

    if (btnNearMe) {
        btnNearMe.addEventListener('click', () => {
            if (!navigator.geolocation) {
                showMessage("Geolocation is not supported by your browser.", "error");
                return;
            }

            btnNearMe.textContent = "Locating...";
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    btnNearMe.innerHTML = `
                        <svg viewBox="0 0 24 24" width="20" height="20" style="margin-right:8px; vertical-align:middle;">
                            <path fill="currentColor" d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-7z"/>
                        </svg> Events Near Me
                    `;
                    // For now, show all events
                    // In a real app, we'd use geohash queries to find nearby events
                    showMessage("Location found! Showing events near you.", "success");
                    const allEvents = await getAllEvents(true); // force refresh
                    await renderEvents(allEvents);
                },
                (error) => {
                    btnNearMe.textContent = "Events Near Me";
                    showMessage("Unable to retrieve your location.", "error");
                    console.error("Geo Error:", error);
                }
            );
        });
    }

    // Create/Edit Event
    if (createEventForm) {
        createEventForm.addEventListener('submit', async (e) => {
            e.preventDefault();

            const groupId = eventGroupSelect ? eventGroupSelect.value : '';
            const zipCode = document.getElementById('evt-location').value;
            const openTo = document.getElementById('evt-open-to').value;

            // Validate: if openTo is group-members, require a group
            if (openTo === 'group-members' && !groupId) {
                showMessage("Please select a group for 'Group Members Only' events", "error");
                return;
            }

            // Geocode the zip code to get coordinates
            const coords = await geocodeZipCode(zipCode);

            const eventData = {
                title: document.getElementById('evt-title').value,
                date: document.getElementById('evt-date').value,
                time: document.getElementById('evt-time').value,
                location: zipCode,
                lat: coords.lat,
                lng: coords.lng,
                openTo: openTo
            };

            // Add groupId if a group is selected
            if (groupId) {
                eventData.groupId = groupId;
            }

            try {
                if (editingEventId) {
                    // Update existing
                    await updateEventInFirestore(editingEventId, eventData);
                    showMessage("Event updated successfully!", "success");
                } else {
                    // Create new
                    await saveEventToFirestore(eventData);
                    showMessage("Event created successfully!", "success");
                }

                cachedEvents = []; // Clear cache
                createEventForm.reset();
                editingEventId = null;
                document.querySelector('#view-create button[type="submit"]').textContent = 'Create Event';
                switchScheduleTab('manage'); // Switch to My Events
            } catch (error) {
                showMessage("Error saving event: " + error.message, "error");
            }
        });
    }

    // ==========================================
    // Journey Tracker System
    // ==========================================

    class JourneyTracker {
        constructor(firestore, user) {
            this.db = firestore;
            this.user = user;
            this.currentLevel = 1;
            this.currentXP = 0;
            this.xpPerLevel = 100; // Base XP needed for level 2
            this.levelMultiplier = 1.5; // Each level requires 1.5x more XP
            this.isLoading = true;

            // DOM Elements
            this.currentLevelEl = document.getElementById('current-level');
            this.currentXPEl = document.getElementById('current-xp');
            this.nextLevelXPEl = document.getElementById('next-level-xp');
            this.xpPercentageEl = document.getElementById('xp-percentage');
            this.xpProgressFillEl = document.getElementById('xp-progress-fill');
            this.addXPBtn = document.getElementById('add-xp-btn');
            this.journeyPathProgress = document.getElementById('journey-path-progress');

            // Load saved data from Firestore
            this.loadProgress().then(() => {
                this.isLoading = false;
                this.updateUI();
            });

            // Set up event listeners
            if (this.addXPBtn) {
                this.addXPBtn.addEventListener('click', () => this.addXP(50));
            }
        }

        // Calculate XP needed for a specific level
        getXPForLevel(level) {
            if (level <= 1) return 0;
            return Math.floor(this.xpPerLevel * Math.pow(this.levelMultiplier, level - 2));
        }

        // Get total XP needed to reach a level
        getTotalXPForLevel(level) {
            let total = 0;
            for (let i = 2; i <= level; i++) {
                total += this.getXPForLevel(i);
            }
            return total;
        }

        // Add experience points
        addXP(amount) {
            this.currentXP += amount;

            // Check for level ups
            while (this.currentXP >= this.getNextLevelXP()) {
                this.levelUp();
            }

            this.updateUI();
            this.saveProgress();
        }

        // Get XP needed for next level
        getNextLevelXP() {
            return this.getXPForLevel(this.currentLevel + 1);
        }

        // Level up
        levelUp() {
            const xpNeeded = this.getNextLevelXP();
            this.currentXP -= xpNeeded;
            this.currentLevel++;

            // Unlock badge
            this.unlockBadge(this.currentLevel);

            // Show level up message
            showMessage(`🎉 Level Up! You are now level ${this.currentLevel}!`, 'success');

            // Animate level up
            this.animateLevelUp();
        }

        // Unlock a badge
        unlockBadge(level) {
            const badge = document.querySelector(`.level-badge[data-level="${level}"] .badge-circle`);
            if (badge) {
                badge.classList.remove('locked');
                badge.classList.add('unlocked');

                // Animate badge
                badge.style.transform = 'scale(1.2)';
                setTimeout(() => {
                    badge.style.transform = 'scale(1)';
                }, 300);
            }
        }

        // Animate level up
        animateLevelUp() {
            if (this.currentLevelEl) {
                this.currentLevelEl.style.transform = 'scale(1.3)';
                this.currentLevelEl.style.color = '#00F5D4';
                setTimeout(() => {
                    this.currentLevelEl.style.transform = 'scale(1)';
                    this.currentLevelEl.style.color = '';
                }, 500);
            }
        }

        // Update UI
        updateUI() {
            const nextLevelXP = this.getNextLevelXP();
            const percentage = Math.min((this.currentXP / nextLevelXP) * 100, 100);

            // Update stats
            if (this.currentLevelEl) this.currentLevelEl.textContent = this.currentLevel;
            if (this.currentXPEl) this.currentXPEl.textContent = this.currentXP;
            if (this.nextLevelXPEl) this.nextLevelXPEl.textContent = nextLevelXP;
            if (this.xpPercentageEl) this.xpPercentageEl.textContent = `${Math.floor(percentage)}%`;

            // Update progress bar
            if (this.xpProgressFillEl) {
                this.xpProgressFillEl.style.width = `${percentage}%`;
            }

            // Update journey path progress
            this.updatePathProgress();
        }

        // Update the path progress
        updatePathProgress() {
            if (!this.journeyPathProgress) return;

            // Calculate progress along the path (0-100% across all 10 levels)
            const overallProgress = ((this.currentLevel - 1) * 10 + (this.currentXP / this.getNextLevelXP()) * 10);
            const pathLength = 2000; // Total length of the path
            const progressLength = (overallProgress / 100) * pathLength;

            this.journeyPathProgress.setAttribute('stroke-dasharray', `${progressLength} ${pathLength}`);
        }

        // Save progress to Firestore
        async saveProgress() {
            if (!this.user || !this.db) {
                console.error('Cannot save progress: user or database not available');
                return;
            }

            try {
                const data = {
                    currentLevel: this.currentLevel,
                    currentXP: this.currentXP,
                    lastUpdated: firebase.firestore.FieldValue.serverTimestamp()
                };

                await this.db.collection('users').doc(this.user.uid).collection('progress').doc('journey').set(data, { merge: true });
                console.log('Progress saved to Firestore');
            } catch (e) {
                console.error('Error saving journey progress to Firestore:', e);
                console.error('Error code:', e.code);
                console.error('Error message:', e.message);
                console.error('User ID:', this.user?.uid);
                console.error('Firestore path:', `users/${this.user?.uid}/progress/journey`);
                throw e; // Re-throw to indicate save failure
            }
        }

        // Load progress from Firestore
        async loadProgress() {
            if (!this.user || !this.db) {
                console.error('Cannot load progress: user or database not available');
                return;
            }

            try {
                const doc = await this.db.collection('users').doc(this.user.uid).collection('progress').doc('journey').get();

                if (doc.exists) {
                    const data = doc.data();
                    this.currentLevel = data.currentLevel || 1;
                    this.currentXP = data.currentXP || 0;
                    console.log('Progress loaded from Firestore:', data);

                    // Unlock all badges up to current level
                    for (let i = 1; i <= this.currentLevel; i++) {
                        this.unlockBadge(i);
                    }
                } else {
                    console.log('No saved progress found, starting fresh');
                    // Initialize with default values in Firestore
                    await this.saveProgress();
                }
            } catch (e) {
                console.error('Error loading journey progress from Firestore:', e);
                console.error('Error code:', e.code);
                console.error('Error message:', e.message);
                console.error('User ID:', this.user?.uid);
                console.error('Firestore path:', `users/${this.user?.uid}/progress/journey`);
                // Initialize with defaults on error
                this.currentLevel = 1;
                this.currentXP = 0;
                this.unlockBadge(1);
            }
        }

        // Reset progress (for testing)
        reset() {
            this.currentLevel = 1;
            this.currentXP = 0;

            // Lock all badges except level 1
            document.querySelectorAll('.badge-circle').forEach((badge, index) => {
                if (index === 0) {
                    badge.classList.add('unlocked');
                    badge.classList.remove('locked');
                } else {
                    badge.classList.add('locked');
                    badge.classList.remove('unlocked');
                }
            });

            this.updateUI();
            this.saveProgress();
        }
    }


    // ==========================================
    // Session Moderation System
    // ==========================================

    let participants = [];

    // DOM Elements for Moderation
    const participantNameInput = document.getElementById('participant-name');
    const addParticipantBtn = document.getElementById('add-participant-btn');
    const participantsList = document.getElementById('participants-list');
    const organizeGroupsBtn = document.getElementById('organize-groups-btn');
    const clearAllBtn = document.getElementById('clear-all-btn');
    const groupsDisplay = document.getElementById('groups-display');
    const groupsContainer = document.getElementById('groups-container');
    const resetGroupsBtn = document.getElementById('reset-groups-btn');

    // Add Participant
    function addParticipant() {
        const name = participantNameInput.value.trim();

        if (!name) {
            showMessage('Please enter a participant name.', 'error');
            return;
        }

        if (participants.includes(name)) {
            showMessage('Participant already added.', 'error');
            return;
        }

        participants.push(name);
        participantNameInput.value = '';
        renderParticipants();
        updateOrganizeButton();
        showMessage(`${name} added successfully!`, 'success');
    }

    // Remove Participant
    function removeParticipant(name) {
        participants = participants.filter(p => p !== name);
        renderParticipants();
        updateOrganizeButton();
        showMessage(`${name} removed.`, 'success');
    }

    // Render Participants List
    function renderParticipants() {
        participantsList.innerHTML = '';

        if (participants.length === 0) {
            participantsList.innerHTML = '<div class="empty-state">No participants added yet.</div>';
            clearAllBtn.style.display = 'none';
            return;
        }

        clearAllBtn.style.display = 'block';

        participants.forEach(name => {
            const item = document.createElement('div');
            item.className = 'participant-item';
            item.innerHTML = `
                <span>${name}</span>
                <button class="remove-btn" onclick="window.removeParticipant('${name}')">
                    <svg viewBox="0 0 24 24" width="20" height="20">
                        <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                    </svg>
                </button>
            `;
            participantsList.appendChild(item);
        });
    }

    // Update Organize Button State
    function updateOrganizeButton() {
        if (participants.length >= 3) {
            organizeGroupsBtn.disabled = false;
        } else {
            organizeGroupsBtn.disabled = true;
        }
    }

    // Grouping Algorithm
    function organizeIntoGroups() {
        if (participants.length < 3) {
            showMessage('You need at least 3 participants to create groups.', 'error');
            return;
        }

        const groups = [];
        const shuffled = [...participants].sort(() => Math.random() - 0.5); // Shuffle participants
        let index = 0;

        const totalParticipants = shuffled.length;
        const remainder = totalParticipants % 3;

        // Calculate how many groups of 3 we can make
        const numGroupsOfThree = Math.floor(totalParticipants / 3);

        // Create groups of 3
        for (let i = 0; i < numGroupsOfThree; i++) {
            const group = {
                id: i + 1,
                members: [
                    { name: shuffled[index++], role: 'moderator' },
                    { name: shuffled[index++], role: 'sharer' },
                    { name: shuffled[index++], role: 'listener' }
                ]
            };
            groups.push(group);
        }

        // Handle remaining participants
        if (remainder === 1) {
            // Add as observer to the first group (making it a group of 4)
            groups[0].members.push({
                name: shuffled[index],
                role: 'observer'
            });
        } else if (remainder === 2) {
            // Create a sharer-listener pair
            groups.push({
                id: groups.length + 1,
                members: [
                    { name: shuffled[index++], role: 'sharer' },
                    { name: shuffled[index], role: 'listener' }
                ]
            });
        }

        renderGroups(groups);
        groupsDisplay.style.display = 'block';
        showMessage('Groups organized successfully!', 'success');
    }

    // Render Groups
    function renderGroups(groups) {
        groupsContainer.innerHTML = '';

        groups.forEach(group => {
            const card = document.createElement('div');
            card.className = 'group-card';

            const membersList = group.members.map(member => `
                <div class="member-item">
                    <span class="role-badge role-${member.role}">${member.role}</span>
                    <span class="member-name">${member.name}</span>
                </div>
            `).join('');

            card.innerHTML = `
                <div class="group-title">Group ${group.id}</div>
                <div class="group-members">
                    ${membersList}
                </div>
            `;

            groupsContainer.appendChild(card);
        });
    }

    // Clear All Participants
    async function clearAllParticipants() {
        const confirmed = await confirmDialog('Are you sure you want to clear all participants?', 'Clear All');
        if (!confirmed) return;

        participants = [];
        renderParticipants();
        updateOrganizeButton();
        groupsDisplay.style.display = 'none';
        showMessage('All participants cleared.', 'success');
    }

    // Reset Groups
    function resetGroups() {
        groupsDisplay.style.display = 'none';
        showMessage('Groups reset. You can add more participants or reorganize.', 'success');
    }

    // Event Listeners for Moderation
    if (addParticipantBtn) {
        addParticipantBtn.addEventListener('click', addParticipant);
    }

    if (participantNameInput) {
        participantNameInput.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                addParticipant();
            }
        });
    }

    if (organizeGroupsBtn) {
        organizeGroupsBtn.addEventListener('click', organizeIntoGroups);
    }

    if (clearAllBtn) {
        clearAllBtn.addEventListener('click', clearAllParticipants);
    }

    if (resetGroupsBtn) {
        resetGroupsBtn.addEventListener('click', resetGroups);
    }

    // Expose functions to window for onclick handlers
    window.removeParticipant = removeParticipant;

    console.log('App.js initialization complete');
}
